import { Component, OnInit, ViewChild, AfterViewInit, HostListener, Input } from '@angular/core';
import { ShapeCreatorService } from '../services/shape-creator.service';
import { ConfigService } from '../services/config.service';
import { AnimatorService } from '../services/animator.service';
import { CommunicationService } from "../services/communication.service";
import { ControllerService } from "../services/controller.service";
import { object_path, object_geom } from "../Objects";
import { NSCModel } from "../services/graphFDL/nsc";

declare var BABYLON;
declare var window;
var debug = false;
var _console = {
  "log": (...args) => {
    if (debug) {
      window.console.log(...args)
    }
  }
}

@Component({
  selector: 'app-gatehouse',
  templateUrl: './staterapp.component.html',
  styleUrls: ['./staterapp.component.scss']
})

export class StaterApp implements OnInit, AfterViewInit {
  @ViewChild('datauxview', { static: true }) public datauxview: any;
  @ViewChild('positiontoolcomponent', { static: true }) public positiontoolcomponent: any;
  _shapestatus = false;
  broadcastIframeSubs: any;
  showQuizCloseBtn: boolean = false;
  testMode: any = "";
  testModePopup: any = "";
  positiontool = false;
  socketcontroler = false;
  shapeCreatorService: ShapeCreatorService;
  process_txt = "Processing...";
  controlsPosition: any = 'Right';
  pcsDemos = []
  selectedDemo = this.pcsDemos[0] || "";
  showAnim = true;
  showLoading = true;
  helicopter_mode = 'park';
  doreset = false;
  styleLength: any = '';
  transMode: boolean = true;
  disableTrans: boolean = false;
  quizCompletedStatus: boolean = true;

  focus_title: string = "";
  windowWidth: any = Math.round(window.innerWidth / 1.8);
  windowHeight: any = Math.round(window.innerWidth / 1.2);
  minWidth: any = Math.round(window.innerWidth / 4) + 'px';
  minHeight: any = Math.round(window.innerWidth / 4.8) + 'px';
  maxWidth: any = Math.round(window.innerWidth / 1.1) + 'px';
  maxHeight: any = Math.round(window.innerHeight / 1.1) + 'px';
  focus_col: string = "#fff"
  controlPanelState: boolean = false;
  broadcastSubs: any;
  showIndexViewButton: boolean = true;
  isAppLoaded: boolean = false;
  mesh_explode = false;
  compProps = { "name": "", "id": "", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false, "material": "" }
  shipChildCompsCntls: any = [];



  quizList: any = [];
  quizCorrectPopup: boolean = false;
  showSSPanel: boolean = true;
  showDrawerPanel: boolean = false;

  @Input() set activeModel(v: any){
    if (v == 'idg') {
      this.appCourseAnimation = undefined;
    }
  }
  engineAnimationPostion: any = {};
  dbobjEngineAnimation: any = {};
  engineAnimationMode: any = false;
  dragModeAnimation: any = false;
  focusTitleStatus: boolean = false;
  appCourseAnimation: boolean = false;

  @Input() set _testMode(v: any) {
    //console.log("testMode", v);
    if (v) {
      // setTimeout(() => {
      if (v === 'quiz') {
        this.quizCompletedStatus = false;
        this.testMode = 'quiz';
        this.testModePopup = 'quiz';
        this.showDrawerPanel = false;
      } else if (v === 'assemble-parts') {
        this.quizCompletedStatus = false;
        this.testMode = 'assemble-parts';
        this.testModePopup = 'assemble-parts';
        this.showDrawerPanel = false;
      }
      // }, 1300);
    } else {
      this.quizCompletedStatus = false;
      this.testMode = "";
      this.testModePopup = "";
    }
  }
  @Input() set controls_position(v: any) {
    this.controlsPosition = v;
  }

  quizStart(mode) {
    this.showLoading = true;
    this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
    this.testModePopup = "";
    this.getAppStatus(mode);
  }

  /**
   * method for get app status
   */
  getAppStatus(mode) {
    let animation = (timer) => {
      //("getAppStatus ", this.isAppLoaded)
      if (this.isAppLoaded) {
        this.isAppLoaded = false;
        if (mode === 'quiz') {
          this.startQuiz();
        } else if (mode === 'assemble-parts') {
          this.startAssembleParts();
        }
        cancelAnimationFrame(setInterval);
      } else {
        setInterval = window.requestAnimationFrame(animation);
      }
    }
    var setInterval = window.requestAnimationFrame(animation);
  }

  startQuiz() {
    this.changeCamView('quiz-home');
    setTimeout(() => {
      this.showQuizCloseBtn = true;
      this.broadcastInfo({ src: 'main', event: 'show-quiz-panel', data: "quiz", key: false });
      this.showLoading = false;
      this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
      this.dragMode = true;
      this.removeDrag("null", true);
      this.reapplyDrag();
    }, 2000);
  }

  startAssembleParts() {
    setTimeout(() => {
      // this.testModePopup = "";
      this.showLoading = false;
      this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
      this.showQuizCloseBtn = true;
      this.broadcastInfo({ src: 'main', event: 'show-assemble-panel', data: "assemble-parts", key: true });
      this.dragMode = true;
      this.removeDrag("null", true);
      this.reapplyDrag();
      this.removeDrag('base_frame');
      this.shipComps.forEach((comp) => {
        if (comp == 'base_frame') {
          this.ctrlServ.showElement(comp);
        } else {
          this.ctrlServ.hideElement(comp);
        }
      })
    }, 1000);
  }

  ngOnInit() {

    this.setShipCompsCntls();
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "controls") {
          if (data.event === 'explode') {
            if (data["key"] === false) {
              this.mesh_explode = false;
              this.resetMeshExplode();
              return
            }
            this.mesh_explode = true;
            this.selectedLabel = null;
            this.explodeMesh(data['data']);
            this.showHideLand(false);
          }
        }
        if (data.src === "main") {
          if (data.src === "main") {
            if (data.event === 'reset-draged-component') {
              let comp = data['data'];
              if (comp) {
                this.resetWrongAnswerdComp(comp);
              }
            }
            if (data.event === 'reset-components') {
              this.resetChildren();
            }
            if (data.event === 'update-draged-comp-position') {
              let comp = data['data'];
              let pos = data['pos'];
              if (comp && pos) {
                this.resetChildren();
                this.updateDragedCompPosition(comp, pos);
              }
            }
            if (data.event === 'stop-drag-component') {
              this.dragMode = !true;
              this.removeDrag("null", true);
            }
          }
        }
        if (data.src === "positionTool") {
          if (data.event === "drag") {
            this.dragModeAnimation = data.dragView;
           // console.log(this.dragModeAnimation)
            if (data.startAnim) {
              this.scene.animationGroups.forEach((anim) => {
                anim.play(true)
              })
            } else {
              this.broadcastInfo({ src: "sidepanel", event: "startAnim", "startAnim": false })
              //this.scene.stopAllAnimations();
            }
          }
        }
        if (data.src === "sidepanel") {
          if(data.event == "showHideIdg"){
            this.profileForAnim(!data['data']);
          }
          if (data.event === "idg-engineAnim") {
            if (data.key) {
              this.engineAnimationMode = data.key;
              this.startEngineAnim();
              setTimeout(() => {
                this.onChangeCameraMode('home');
              }, 500);

            } else {
              this.engineAnimationMode = data.key;
              this.stopEngineAnim();
            }
          }
          //idg-engineSmoke
          if (data.event === "idg-engineSmoke") {
            if (data.key) {             
              this.addIDGSmoke();     

            } else {
              this.removeIDGSmoke();
            }
          }
          if (data.event === "engine-trans-toggle") {
            this.engineTransToggle(data.key);
          }
          if (data.event === "idg-controlChange") {
            let obj = data['data'];
            this.onControlChange(obj)
          }
          if (data.event === "rhib-controlChange") {
            let obj = data['data'];
            this.onControlChange(obj)
          }
          if (data.event === "idg-engineAnim-node") {
            let obj = data['data'];
            if (obj) {
              if (obj == 'idg') {
                this.appCourseAnimation = true;
              } else if (obj == 'idg-animation') {
                this.appCourseAnimation = true;
              } else {
                this.appCourseAnimation = false;
              }
            } else {
              this.appCourseAnimation = false;
            }
          }
        }
      })

    // this.broadcastIframeSubs = this.communicationServ.getIframeInstance()
    //   .subscribe((data: any) => {
    //     if (data.iframeConnection === "slms-connection") {
    //       if (data.event === 'Translate') {
    //         // this.languageSelected = data.data;
    //       }
    //       if (data.event === 'loginInfo') {
    //         this.userId = data.data['userId'];
    //         this.userName = data.data['userName'];
    //         this.accountEmail = data.data['accountEmail'];
    //         this.loginInfo = data.data;
    //         this.configService.accessToken = data.data['accessToken'];
    //         this.configService.refershToken = data.data['refershToken'];
    //         console.log("navyscs loginInformation ",data.data);
    //         this.nscmodel.userId=  data.data['userId'];
    //       }
    //     }
    //   })

  }

  // userId
  // userName
  // accountEmail
  // loginInfo
  @HostListener('window:resize', ['$event']) onResize(event) {
   // console.log(event)
    //console.log(event.target.innerWidth, event.target.innerHeight);
    +'px';
    if (window.innerWidth < 1024) {
      if (!this.getDatascape()) return;
      this.getDatascape().moveCamera({ distance: 15 });
    } else {
      if (!this.getDatascape()) return;
      this.getDatascape().moveCamera({ distance: 10 });
    }
  }

  removeLoader() {
    let ldiv = document.getElementById("babylonjsLoadingDiv");
    if (ldiv) {
      ldiv.remove();
    }
  }
  nscmodel
  ern = '';
  constructor(private ctrlServ: ControllerService, private configService: ConfigService, private animatorService: AnimatorService, private communicationServ: CommunicationService) {
    this.nscmodel = new NSCModel(this.configService, this.communicationServ, this.ern);
    this.windowWidth = Math.round(window.innerWidth / 2.8);
    this.windowHeight = Math.round(window.innerWidth / 4.5);
    this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
  }

  broadcastInfo(data: any) {
    this.communicationServ.getInstance().next(data);
  }

  broadcastIframeInfo(data: any) {
    this.communicationServ.createIframeInstance(data);
  }

  generate() {
    var jsonArr;
    var targetArr = [];
    jsonArr.forEach(element => {
      targetArr.push(element.name);
    });
    // localStorage.setItem('targetArr',JSON.stringify(targetArr));
  }

  @HostListener('click', ['$event']) onMouseup(event) {
    // event.preventDefault();
    // event.target.closest('div.image').remove();
  }
  mouseDownElem: any = '';
  @HostListener('mousedown', ['$event']) onMouseDown(event) {
    // console.log('mousedown', event);
    this.mousestate = "down";
    if (this.onHoverElem) {
      this.offHover(this.onHoverElem);
    }
    if (event.target.className == 'mat-card') {
      if (event.target.childNodes[0].className == 'resizer') {
        this.mouseDown = true;
        this.mouseDownElem = event
        // if(window.innerWidth/3.5<event.target.clientWidth){
        //   this.windowWidth = event.target.clientWidth;
        // }
        // if(window.innerHeight/3.5<event.target.clientHeight&&window.innerWidth/3.5<event.target.clientWidth){
        //   this.windowHeight = event.target.clientHeight/1.2;
        // }
      }
    }
  }
  mouseDown: any = false;
  mousepos = []
  @HostListener('mouseup', ['$event']) onMouseUp(event) {
    this.mouseDown = false;
    this.mousestate = "up";
    if (this.onHoverElem) {
      this.offHover(this.onHoverElem);
    }
    if (this.mouseDownElem && this.mouseDownElem.target)
      this.mouseDownElem.target.style.resize = 'both'
  }
  @HostListener('mousemove', ['$event']) onMouseMove(even) {
    _console.log('mousemove', even.target)
    //this.mousestate=this.mousestate==="up"?"move":this.mousestate;
    var event = this.mouseDownElem;
    //this.mousepos=[even.clientX,even.clientY]
  }
  /***
   * Reset tag
   */
  resetTagViewMode() {
    this.onShowAllTag({ state: false }, false);
    this.tagStatus = false;
    this.pickElement = false;
    this.selectedelem = '';
    this.pauseAnim = false;
  }
  /***
   * Add Pickleft event start
   */
  pickElement: any = false;
  tagObjectList: any;
  tagStatus: any = false;
  pickedElement: any;
  pickEvent: boolean = false;
  hitPosition: any;
  pickleftAttach() {
    // this.pickleftAttachStatus= true;
    // let  allObject = this.datauxview.allObjects();
    // let allObjKeys = Object.keys(allObject);
    // this.tagObjectList = allObjKeys;
    var shipCombainSensor = this.shipComps.concat(this.sensors);
    //_console.log("shipCombainSensor", shipCombainSensor.length, this.shipComps.length, this.sensors.length);
    var shipCombainSensorTarget = shipCombainSensor.concat(this.cameras)
    //_console.log("shipCombainSensorTarget", shipCombainSensorTarget.length, this.cameras.length);
    shipCombainSensorTarget.forEach((element, i) => {
      //_console.log("pickaddObj", element)
      let el = this.datauxview.getElementId(element);
      let info = this.getCtrlData(element);
      let isSub = info && info.isSub;
      let isSensor = this.sensors.includes(element) || this.cameras.includes(element)
      if (isSub || isSensor) {
        this.datauxview.getDatascape().attach(el, {
          actions: {
            pickLeft: [(evt, elem) => {
              //_console.log("event", evt);
              if (evt.button === 0) {
                this.pickedElement = elem;
                this.pickEvent = true;
              }
            }]
            // hoverOn: [(evt, elem) => {this.onHoverElem=true; this.onHover(elem); }],
            // hoverOff: [(evt, elem) => { this.onHoverElem=false; this.offHover(elem); }],
          }
        });
      }
    });
    this.shipComps.forEach((element, i) => {
      // _console.log("hover", element)
      let el = this.datauxview.getElementId(element);
      let info = this.getCtrlData(element);
      let isSub = info && info.isSub;
      if (isSub) {
        this.datauxview.getDatascape().attach(el, {
          actions: {
            pickLeft: [(evt, elem) => {
              if (evt.button === 0) {
                let props = this.datauxview.getDatascape().props(elem);
                let comp = props['id'];
                if (this.mesh_explode) {
                  if (this.focusMode) return;
                  let info = this.getCtrlData(comp);
                  this.broadcastInfo({ src: 'main', event: 'show-focus-mode', data: info, key: "" });
                }
              }
            }],
            hoverOn: [(evt, elem) => {
              if (this.testMode) {
                return;
              }
              if (this.mousestate == 'down') {
                if (this.onHoverElem) {
                  this.offHover(this.onHoverElem);
                }
                return
              }
              this.onHoverElem = elem;
              let dfx = this.getDatascape();
              let hp = dfx.getHitPosition()
              // this.hitPosition = hp.pickedPoint;
              this.hitPosition = this.compDefPos[this.datauxview.getDatascape().props(elem).id].bound[0];
              var id = this.datauxview.getDatascape().props(elem).id;
              _console.log(this.datauxview.getDatascape().props(elem).id, this.compDefPos[this.datauxview.getDatascape().props(elem).id].bound[0], "onHover");
              // setTimeout(() => {
              if (this.onHoverElem) {
                let props1 = this.datauxview.getDatascape().props(elem);
                let props2 = this.datauxview.getDatascape().props(this.onHoverElem);
                if (props1.id === props2.id) {
                  if (this.testMode || this.focusMode) return;
                  this.onHover(elem);
                }
              }
              // }, 500)
            }],
            hoverOff: [(evt, elem) => {
              this.onHoverElem = elem; this.offHover(elem);
            }],
          }
        });
      }

    });
    // this.generate();
  }
  onHoverElem: any = false;
  checked: any = true;
  onHover(elem) {
    this.onHoverElem = elem;
    _console.log("hoveron", elem);
    let ele = this.datauxview.getDatascape().props(elem);
    _console.log("hoveron", elem, ele);
    this.shipCompFocusStatus();
    let info = this.getCtrlData(ele.id);
    let isSub = info && info.isSub;
    //uncheck
    this.checked = true;
    let cat = Object.keys(this.shipCompsCntls);
    cat.forEach((catElement) => {
      this.shipCompsCntls[catElement].forEach((sensorEle, i) => {
        if (this.shipCompsCntls[catElement][i].isSub) {
          let idx = this.shipCompsCntls[catElement].findIndex(e => e.id == ele.id);
          if (idx > -1) {
            if (!this.shipCompsCntls[catElement][idx].selected) {
              this.checked = false;
            }
          }
        }
      });
    });
    if (this.checked && !this.multipleTagStatus && !this.shipCompFocusState && this.viewMode == 'solid' && isSub) {
      // this.addObserver(elem);
      // this.observableTag(ele);
      this.tagElement = ele;
      this.pickElement = true;
      if (this.mesh_explode) {
        this.focus_title = info.name;
      } else {
        this.focus_title = info.name;
        this.focusTitleStatus = true
        this.createLabelObject('cube', this.hitPosition, ele.id);
      }
    }
  }
  offHover(elem) {
    _console.log("hoveroff", elem)
    this.onHoverElem = '';
    if (this.mesh_explode && !this.focusMode) {
      this.focus_title = ""
    }
    this.focusTitleStatus = false
    this.focus_title
    // if(!this.multipleTagStatus && !this.shipCompFocusState && this.viewMode == 'solid' && this.animStatus !== 'playing'){
    if (this.tagElement != '') {
      document.getElementById('tooltip_' + this.tagElement.id).style.display = "none";
      // document.getElementById('label_' + this.tagElement.id).style.display = "none";
      // this.onControlChange({event: 'locate',name:this.tagElement.id,state:false });
      this.pickElement = false;
      this.removeObserver(elem);
      var id = 'tooltip_' + this.tagElement.id;
      this.labelObjectShow(this.tagElement.id, false);
      let buildModel = this.datauxview.getElementId(id);
      // this.dfx.modify(buildModel, { profile:'hidden' });
      this.tagElement = '';
      // this.pickElement =false;
    }
  }

  objDrag: boolean = false;
  altKey: boolean = false;
  targetClicked: boolean = false;
  dragChange(e) {
    _console.log("drag", e);
    this.objDrag = e === true;
    if (!this.objDrag) {
      if (this.onHoverElem != '') {
        this.offHover(this.onHoverElem);
      }
      if (e === 'dblclick' || this.altKey) {
        this.onDoubleClick();
      } else {
        /* setTimeout(()=>{
          let isCanvas = document.activeElement.tagName==='CANVAS';
          if(isCanvas&&!this.targetClicked){
            if(this.animStatus==='playing'){
              this.triggerCompAnim("CH148");
            }
          }
        },500) */
        if (this.pickEvent) {
          this.pickDragObject();
          // this.pickEvent=false;
        }
      }
    }
    this.pickEvent = false;
  }
  onDoubleClick() {
    let dfx = this.getDatascape();
    if (dfx) {
      let hp = dfx.getHitPosition();
      if (hp.pickedPoint) {
        let target = { x: hp.pickedPoint.x, y: hp.pickedPoint.y, z: hp.pickedPoint.z };
        this.moveCameraTo(null, { target });
      }
    }
  }
  isTarget(el) {
    let dfx = this.getDatascape()
    let props = dfx.props(el);
    let id = props.id;
    let targ = this.sensors.includes(id) || this.cameras.includes(id);
    return targ;
  }
  pickDragObject() {
    if (this.viewMode != 'wireframe' && this.pickedElement) {
    }
  }
  isSelectedObject(id) {
    let info = this.getCtrlData(id);
    let sensor = this.sensors.includes(id) || this.cameras.includes(id);
    return (info && info.selected) || sensor;
  }
  /***
   * obj pick show tag
   */
  selectedSensorItem: any = [];
  selectedCameraItem: any = [];
  shipSmartSensor = []
  shipCompFocus(id, action) {
    let cat = Object.keys(this.shipCompsCntls);
    cat.forEach(element => {
      this.shipCompsCntls[element].forEach((elem, i) => {
        // _console.log("element", elem);
        if (action == 'pickElem') {
          if (elem.id == id) {
            this.shipCompsCntls[element][i].focus = this.tagStatus;
          }
        }
        if (action == 'multiTag') {
          this.shipCompsCntls[element][i].focus = false;
        }
      });
    });
  }
  /***
   * Show Tag for object
   */
  selectedelem = '';
  showTag(elem) {
    let ele = this.datauxview.getDatascape().props(elem);
    if (!this.selectedelem) {
      this.addObserver(elem);
      this.selectedelem = elem;
      this.observableTag(ele);
    } else {
      this.removeObserver(this.selectedelem);
      this.addObserver(elem);
      this.selectedelem = elem;
      this.observableTag(ele);
    }
  }
  /***
   * Show All Tag for object
   */
  multiTagShowList = [];
  multipleTagStatus: boolean = false;
  showExternalTools = false;
  onShowAllTag(e, status) {
    setTimeout(() => {
      this.showExternalTools = true;
    }, 1000);
    if (this.viewMode !== 'wireframe') {
      if (this.pickElement) {
        if (this.selectedelem != "") {
          let ele = this.datauxview.getDatascape().props(this.selectedelem);
          this.onControlChange({ event: 'locate', name: ele.id, state: false });
        }
      }
      _console.log("showTag");
      this.multipleTagStatus = e.state;
      this.animatorService.setTagStatus('multipleTagStatus', this.multipleTagStatus)
      this.shipCompFocusStatus();
      if (!this.shipCompFocusState) {
        this.pickElement = e.state;
      } else {
        this.pickElement = false;
      }
      if (this.disableTrans) {
        this.showHideCompTargets(false)
      } else {
        this.showHideCompTargets(!this.multipleTagStatus)
      }

      this.shipComps.forEach((element, i) => {
        var checked = true;
        let info = this.getCtrlData(element);
        if (info.isSub) {
          let el = this.datauxview.getElementId('tooltip_' + element);
          if (e.state) {
            if (!this.shipCompFocusState) {
              let cat = Object.keys(this.shipCompsCntls);
              cat.forEach((catElement) => {
                this.shipCompsCntls[catElement].forEach((sensorEle, i) => {
                  if (this.shipCompsCntls[catElement][i].isSub) {
                    let idx = this.shipCompsCntls[catElement].findIndex(ele => ele.id == element);
                    if (idx > -1) {
                      if (!this.shipCompsCntls[catElement][idx].selected) {
                        checked = false;
                      }
                    }
                  }
                });
              });
              //console.log("multi", element, checked)
              if (checked) {
                // this.multiTagShowList.push(element);
                this.addObserver(el);
                // let ele = this.datauxview.getDatascape().props(el);
              } else {
                let dom = document.getElementById('tooltip_' + element);
                if (dom) {
                  dom.style.display = "none";
                  this.removeObserver(el);
                }
              }
            }
            // this.observableMultiTag(ele);

          } else {
            // if(! this.shipCompFocusState ){
            let dom = document.getElementById('tooltip_' + element);
            if (dom) {
              dom.style.display = "none";
              this.removeObserver(el);
            }
            // let ele = this.datauxview.getDatascape().props(el);
            // }
            // this.observableMultiTag(ele);
          }
          if (status == true) {
            this.shipCompFocus(element, 'multiTag')
          }
        }
      })
      // if (status == true) {
      //this.datauxview.Camera('home');
      // }
    }
  }
  /***
   * shipcomponent status check
   */
  shipCompFocusState: any = false;
  shipCompFocusElem: any = '';
  shipCompFocusStatus() {
    this.shipCompFocusState = false;
    this.shipCompFocusElem = '';
    let cat = Object.keys(this.shipCompsCntls);
    cat.forEach(element => {
      let idx = this.shipCompsCntls[element].findIndex(e => e.focus == true);
      if (idx > -1) {
        this.shipCompFocusState = true;
        _console.log("shipCompFocusStatusr", this.shipCompFocusState);
        this.shipCompFocusElem = this.shipCompsCntls[element][idx];
      }
    })
    _console.log("shipCompFocusStatus", this.shipCompFocusState)
  }
  /***
   * shipcomponent status check
   */

  // sensorCheckHideShow() {
  //   let cat = Object.keys(this.shipCompsCntls);
  //   cat.forEach(element => {
  //     let idx = this.shipCompsCntls[element].findIndex(e => e.selected == true);
  //     if (idx > -1) {
  //       this.shipCompCheckState = true;
  //       _console.log("shipCompCheckElem", this.shipCompCheckState);
  //       this.shipCompCheckElem = this.shipCompsCntls[element][idx];
  //     }

  //   })
  //   _console.log("shipCompCheckElem", this.shipCompCheckState)
  // }
  /**
  * add an Observer attach to 3d object
  */
  addObserver(elem) {
    if (!elem) {
      return;
    }
    this.datauxview.getDatascape().attach(elem, {
      observer: {
        callback: this.assignTagProperties.bind(this),
        options: { no2D: false }
      }
    });
  }

  /**
   * Remove an Observer detach to 3d object
   */
  removeObserver(elem) {
    if (!elem) {
      return;
    }
    this.datauxview.getDatascape().detach(elem, {
      observer: {
        callback: this.assignTagProperties.bind(this),
        options: { no2D: false }
      }
    });
  }
  /***
   * tagElement added
   */
  tagElement: any = "";
  selectEle: any = '';
  observableTag(props) {
    var event = 'locate';
    if (props != '') {
      if (this.tagElement) {
        document.getElementById('tooltip_' + this.tagElement.id).style.display = "none";
        // this.onControlChange({event: 'locate',name:this.tagElement.id,state:false });
      }
      this.tagElement = props;
      if (this.selectEle) {
        if (this.selectEle == this.tagElement.id) {
          // this.pickElement = !this.pickElement;
          this.pickElement = true;
          if (this.pickElement) {
            // this.onControlChange({event: 'locate',name:this.tagElement.id,state:true });
          }
        } else {
          this.selectEle = this.tagElement.id;
          this.pickElement = true;
          // this.onControlChange({event: 'locate',name:this.tagElement.id,state:true });
        }
      } else {
        this.selectEle = this.tagElement.id;
        this.pickElement = true;
        // this.onControlChange({event: 'locate',name:this.tagElement.id,state:true });
      }
    }
  }
  createLabelObject(shape, pos, uid) {
    var id = 'tooltip_' + uid;
    var elem = this.datauxview.getElementId(id);
    // var pos = e.pickedPoint;
    if (!elem) {
      var size = 0.0001;
      let profiles = { transparent: { material: 'transparent' }, regular: { material: 'hidden_obj' } };
      let settings = { 'geometry': { 'orientation': { x: 0, y: 0, z: 0 }, position: { x: pos.x, y: pos.y, z: pos.z }, size: size } };
      this.datauxview.addElement(shape, id, profiles, settings);
      let buildModel = this.datauxview.getElementId(id);
      let base = this.datauxview.getElementId(uid);
      let pmesh = this.dfx.getElementMesh(base);
      let cmesh = this.dfx.getElementMesh(buildModel);
      cmesh.setParent(pmesh);
      //this.dfx.modify(buildModel, { profile:'transparent' });
    }
    if (this.selectedLabel != id) {
      // if(this.selectedLabel){
      //   // this.labelObjectShow(id,false);
      //   // let buildModel = this.datauxview.getElementId(id);
      //   // this.dfx.modify(buildModel, { profile:'hidden' });
      // }else{
      let buildModel = this.datauxview.getElementId(id);
      //this.dfx.modify(buildModel, { profile:'transparent' });
      if (this.pickElement) {
        this.labelObjectShow(id, true)
      }
      // }
    }
  }
  selectedLabel: any;
  labelObjectShow(element, flag) {
    let el = this.datauxview.getElementId(element);
    //console.log("el----- : ", el);
    if (el) {
      if (flag) {
        this.selectedLabel = element;
        // this.hideStaticObjTag(element)
        this.addObserver(el);
      } else {
        let dom = document.getElementById(element);
        if (dom) {
          dom.style.display = "none";
          delete this.selectedLabel;
          this.removeObserver(el);
        }
      }
    }

  }
  // /***
  //  * Multi tagElement added
  //  */
  // observableMultiTag(props){
  //   let idx = this.tagElementarr.findIndex(e => e.id == id);
  //       // _console.log(this.tagElementarr,idx)
  //       if (idx >= 0) {
  //         var pop = document.getElementById('tooltip_' + id);
  //         this.objObserver(pop, position2D, this.tagElementarr[idx]);
  //         this.pickElement = true;
  //       }
  // }
  /***
   * tag observer properties
   */
  assignTagProperties(options) {
    const { id, position, position2D, uuid, tag, visibility } = Object.assign({}, options);
    // if (this.tagElement.id === id) {
    // _console.log("obc", this.tagElement.id, id)
    // var pop = this.objTag.nativeElement;
    if (this.multipleTagStatus) {
      let elem = this.datauxview.getElementId(id);
      let props = this.datauxview.getDatascape().props(elem);
      var pop = document.getElementById(id);
      this.objObserver(pop, position2D, props);
    } else {
      if (this.selectedLabel === id) {
        var pop = document.getElementById(this.selectedLabel);
        // var pop = document.getElementById('label_' + this.tagElement.id);
        this.objObserver(pop, position2D, this.tagElement);
      }
    }
    // }
  }

  /****
   * observable Tag
   */
  tagAfterTagIdArr: any = [];
  objObserver(pop, position, element) {
    if (element != "") {
      // position[0]=this.hitPosition.x<0?this.hitPosition.x*-1500:this.hitPosition.x*1500;
      // position[1]=this.hitPosition.y<0?this.hitPosition.y*-500:this.hitPosition.y*500;
      // position[0]=this.hitPosition.x*1800;
      // position[1]=this.hitPosition.y*400;
      _console.log(element.id, "position :", position, this.hitPosition);
      const x = position[0];
      const y = position[1];
      let info = this.getCtrlData(element.id);
      // const canvas = null;
      // var canvas = this.datauxview.getCanvas();
      // console.log("canvas", canvas.width,canvas.height);
      const dpr = window.devicePixelRatio;
      // const within_window = (x > 10 && x < canvas.width) && (y > 10 && y <= canvas.height);
      if (this.pickElement) {
        // if (within_window) {
        let mpop = pop.getElementsByClassName("tooltip_popup")[0]
        // _console.log("material",element.profile.material)
        var width = -mpop.offsetWidth / 2;//1555 - window.innerWidth;
        var height = 35;// 815 - window.innerHeight;
        pop.style.left = (Number(x) + width) + 'px';
        pop.style.bottom = (Number(y) + height) + 'px';
        // console.log(window.innerWidth, window.innerHeight, x, (Number(x) - 50) + 'px', y, (Number(y) + 25) + 'px')
        var material = info && info.profile ? info.profile.split('_')[1] : "#fefefe";
        let color = 'black'
        if (this.viewObjectMode === 'texture') {
          material = 'lightgrey';
          //color='white';
        }
        // if (element.profile.material == undefined) {
        //   material = 'grey';
        // }
        // _console.log("color_code",material);
        // pop.children[0].children[0].children[0].children[0].style.color=color;
        // pop.children[0].children[0].children[0].children[0].style.backgroundColor = material;
        //  if (this.tagAfterTagIdArr.length == 0) {
        //   this.tagAfterTagIdArr.push(element.id);
        //   document.head.appendChild(document.createElement("style"));
        //   document.head.getElementsByTagName('style')[Number(this.styleLength)].innerHTML = "#tooltip_popup_content_" + element.id + "::after {border-color:" + material + " !important;}";
        //   this.styleLength = this.styleLength + 1;
        // } else {
        //   let idx = this.tagAfterTagIdArr.findIndex(e => e == element.id);
        //   if (idx < 0) {
        //     this.tagAfterTagIdArr.push(element.id);
        //     document.head.appendChild(document.createElement("style"));
        //     document.head.getElementsByTagName('style')[Number(this.styleLength)].innerHTML = "#tooltip_popup_content_" + element.id + "::after {border-color:" + material + " !important;}";
        //     this.styleLength = this.styleLength + 1;
        //   }
        // }
        pop.style.display = 'block';
        pop.style.position = 'absolute';
        // pop.dataset.lastx = Number(x);
        // pop.dataset.lasty = Number(y);
        // } else {
        //   pop.style.display = 'none';
        // }
      } else {
        if (pop != null) {
          pop.style.display = 'none';
        }
      }
    }
  }
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }
  shipComps = []
  compTargets = []
  sensors = []
  cameras = [];
  shipCameras = []
  compDefPos = {};
  shipCompsCntls = {};
  shipElems;
  bckupShip_comp_ctl_list: any = [];

  setShipCompsCntls() {
    this.shipCompsCntls["Components"] = 
  [{"name":"air_intake","id":"air_intake","children":[{"name":"air_intake","id":"air_intake","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"base_frame","id":"base_frame","children":[{"name":"base_frame","id":"base_frame","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Batt Tray 2717-03","id":"Batt Tray 2717-03","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"panel_frame","id":"panel_frame","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1","id":"Part 1","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_001","id":"Part 1_001","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_008","id":"Part 1_008","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_009","id":"Part 1_009","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rad_frame","id":"rad_frame","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"camshaft_gear","id":"camshaft_gear","children":[{"name":"camshaft_gear","id":"camshaft_gear","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"camshaft","id":"camshaft","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"cold_water_from_rad","id":"cold_water_from_rad","children":[{"name":"cold_water_from_rad","id":"cold_water_from_rad","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"control_panel","id":"control_panel","children":[{"name":"control_panel","id":"control_panel","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_002","id":"Part 1_002","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_003","id":"Part 1_003","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_004","id":"Part 1_004","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_005","id":"Part 1_005","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_011","id":"Part 1_011","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"Part 1_013","id":"Part 1_013","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"TG410 Assembly ","id":"TG410 Assembly ","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crankshaft","id":"crankshaft","children":[{"name":"crankshaft","id":"crankshaft","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crankshaft_pulley","id":"crankshaft_pulley","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crankweight_1","id":"crankweight_1","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crankweight_2","id":"crankweight_2","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crankweight_3","id":"crankweight_3","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crankweight_4","id":"crankweight_4","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"flywheel-1_0","id":"flywheel-1_0","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"cylinder head","id":"cylinder head","children":[{"name":"cylinder head","id":"cylinder head","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"cylinder head exhaust passages","id":"cylinder head exhaust passages","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"cylinder head intake passages","id":"cylinder head intake passages","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"cylinder head water passages","id":"cylinder head water passages","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rocker arm cover","id":"rocker arm cover","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"cylinder_head_assembly","id":"cylinder_head_assembly","children":[{"name":"cylinder_head_assembly","id":"cylinder_head_assembly","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"value_train_1","id":"value_train_1","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"value_train_2","id":"value_train_2","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"value_train_3","id":"value_train_3","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"value_train_4","id":"value_train_4","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"engine_block","id":"engine_block","children":[{"name":"engine_block","id":"engine_block","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crank_bearings","id":"crank_bearings","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crank_bearings_cap","id":"crank_bearings_cap","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"crankcase_vent","id":"crankcase_vent","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"cylinder_sleeves","id":"cylinder_sleeves","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"engine_rad","id":"engine_rad","children":[{"name":"engine_rad","id":"engine_rad","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"exhaust manifold","id":"exhaust manifold","children":[{"name":"exhaust manifold","id":"exhaust manifold","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"exhaust_system","id":"exhaust_system","children":[{"name":"exhaust_system","id":"exhaust_system","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"flywheel_exterior","id":"flywheel_exterior","children":[{"name":"flywheel_exterior","id":"flywheel_exterior","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel injector_1","id":"fuel injector_1","children":[{"name":"fuel injector_1","id":"fuel injector_1","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel injector_2","id":"fuel injector_2","children":[{"name":"fuel injector_2","id":"fuel injector_2","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel injector_3","id":"fuel injector_3","children":[{"name":"fuel injector_3","id":"fuel injector_3","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel injector_4","id":"fuel injector_4","children":[{"name":"fuel injector_4","id":"fuel injector_4","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel pump","id":"fuel pump","children":[{"name":"fuel pump","id":"fuel pump","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel_lift_pump","id":"fuel_lift_pump","children":[{"name":"fuel_lift_pump","id":"fuel_lift_pump","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel_line_to_injector_pump","id":"fuel_line_to_injector_pump","children":[{"name":"fuel_line_to_injector_pump","id":"fuel_line_to_injector_pump","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel_lines_back_to_tank","id":"fuel_lines_back_to_tank","children":[{"name":"fuel_lines_back_to_tank","id":"fuel_lines_back_to_tank","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuel_lines_to_injectors","id":"fuel_lines_to_injectors","children":[{"name":"fuel_lines_to_injectors","id":"fuel_lines_to_injectors","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"fuelpump_gear","id":"fuelpump_gear","children":[{"name":"fuelpump_gear","id":"fuelpump_gear","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"generator","id":"generator","children":[{"name":"generator","id":"generator","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"generator_exterior","id":"generator_exterior","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"generator_moving","id":"generator_moving","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"generator_static","id":"generator_static","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"head_gasket","id":"head_gasket","children":[{"name":"head_gasket","id":"head_gasket","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"hot_water_out","id":"hot_water_out","children":[{"name":"hot_water_out","id":"hot_water_out","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"hot_water_to_rad","id":"hot_water_to_rad","children":[{"name":"hot_water_to_rad","id":"hot_water_to_rad","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"idler_gear","id":"idler_gear","children":[{"name":"idler_gear","id":"idler_gear","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"intercooler","id":"intercooler","children":[{"name":"intercooler","id":"intercooler","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"intercooler_cold","id":"intercooler_cold","children":[{"name":"intercooler_cold","id":"intercooler_cold","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"intercooler_hot","id":"intercooler_hot","children":[{"name":"intercooler_hot","id":"intercooler_hot","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"intercooler_rad","id":"intercooler_rad","children":[{"name":"intercooler_rad","id":"intercooler_rad","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"lifting_eyes","id":"lifting_eyes","children":[{"name":"lifting_eyes","id":"lifting_eyes","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oil pan","id":"oil pan","children":[{"name":"oil pan","id":"oil pan","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"dip_stick","id":"dip_stick","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oil","id":"oil","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpan_gasket","id":"oilpan_gasket","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpump","id":"oilpump","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oil_filter_attach","id":"oil_filter_attach","children":[{"name":"oil_filter_attach","id":"oil_filter_attach","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oil_filter","id":"oil_filter","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_002","id":"oilpath_002","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_003","id":"oilpath_003","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpaths_camshaft","id":"oilpaths_camshaft","children":[{"name":"oilpaths_camshaft","id":"oilpaths_camshaft","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"camshaft_bearing","id":"camshaft_bearing","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"camshaft_oilpath_001","id":"camshaft_oilpath_001","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"camshaft_oilpath_002","id":"camshaft_oilpath_002","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"camshaft_oilpath_003","id":"camshaft_oilpath_003","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpaths_pistons","id":"oilpaths_pistons","children":[{"name":"oilpaths_pistons","id":"oilpaths_pistons","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_004","id":"oilpath_004","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_005","id":"oilpath_005","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_006","id":"oilpath_006","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_007","id":"oilpath_007","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_008","id":"oilpath_008","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_009","id":"oilpath_009","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_010","id":"oilpath_010","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_011","id":"oilpath_011","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_012","id":"oilpath_012","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpath_013","id":"oilpath_013","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpump_gear","id":"oilpump_gear","children":[{"name":"oilpump_gear","id":"oilpump_gear","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"oilpump_idler_gear","id":"oilpump_idler_gear","children":[{"name":"oilpump_idler_gear","id":"oilpump_idler_gear","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rad_fan","id":"rad_fan","children":[{"name":"rad_fan","id":"rad_fan","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rad_fan_pulley","id":"rad_fan_pulley","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rockerShaft","id":"rockerShaft","children":[{"name":"rockerShaft","id":"rockerShaft","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rockerShaft_oilpath","id":"rockerShaft_oilpath","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rockerShaft_oilpath_001","id":"rockerShaft_oilpath_001","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rockerShaft_screws","id":"rockerShaft_screws","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"rockerShaft_springs","id":"rockerShaft_springs","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"starter_motor","id":"starter_motor","children":[{"name":"starter_motor","id":"starter_motor","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"battery","id":"battery","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"engine_alternator","id":"engine_alternator","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"wiring","id":"wiring","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"timing_gears_cover","id":"timing_gears_cover","children":[{"name":"timing_gears_cover","id":"timing_gears_cover","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"turbocharger","id":"turbocharger","children":[{"name":"turbocharger","id":"turbocharger","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"water_pump","id":"water_pump","children":[{"name":"water_pump","id":"water_pump","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false},{"name":"cold_water_in","id":"cold_water_in","children":[],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}],"opacity":"solid","visible":true,"focus":false,"selected":true,"color":"#ffbeb4","isSub":true,"sensors":[],"animateMedia":false,"hastarget":false}]
    //   { "name": "air_intake", "id": "air_intake", "children": [{ "name": "air_intake", "id": "air_intake", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "generator", "id": "generator", "children": [{"name": "connector", "id": "connector", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "terminal_box", "id": "terminal_box", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "generator", "id": "generator", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "base_frame", "id": "base_frame", "children": [{ "name": "Batt Tray 2717-03", "id": "Batt Tray 2717-03", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1", "id": "Part 1", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1_001", "id": "Part 1_001", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1_008", "id": "Part 1_008", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1_009", "id": "Part 1_009", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "base_frame", "id": "base_frame", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "cold_water_from_rad", "id": "cold_water_from_rad", "children": [{ "name": "cold_water_from_rad", "id": "cold_water_from_rad", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "control_panel", "id": "control_panel", "children": [{ "name": "Part 1_002", "id": "Part 1_002", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1_003", "id": "Part 1_003", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1_004", "id": "Part 1_004", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1_005", "id": "Part 1_005", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1_011", "id": "Part 1_011", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "Part 1_013", "id": "Part 1_013", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "TG410 Assembly", "id": "TG410 Assembly", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "control_panel", "id": "control_panel", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "cylinder head", "id": "cylinder head", "children": [{ "name": "rocker arm cover", "id": "rocker arm cover", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "cylinder head", "id": "cylinder head", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "engine_block", "id": "engine_block", "children": [{ "name": "crankcase_vent", "id": "crankcase_vent", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "crankshaft-27_0", "id": "crankshaft-27_0", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "lifting_eyes", "id": "lifting_eyes", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false },
    //    { "name": "timimg_gears_cover", "id": "timimg_gears_cover", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "oil_filter_attach", "id": "oil_filter_attach", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "rad_fan_pulley", "id": "rad_fan_pulley", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "rad_fan", "id": "rad_fan", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "engine_block", "id": "engine_block", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "engine_rad", "id": "engine_rad", "children": [{ "name": "engine_rad", "id": "engine_rad", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "exhaust_system", "id": "exhaust_system", "children": [{ "name": "exhaust_system", "id": "exhaust_system", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "flywheel-1_0", "id": "flywheel-1_0", "children": [{ "name": "flywheel_exterior", "id": "flywheel_exterior", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "flywheel-1_0", "id": "flywheel-1_0", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "fuel_lift_pump", "id": "fuel_lift_pump", "children": [{ "name": "fuel_lift_pump", "id": "fuel_lift_pump", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, 
    //    { "name": "fuel_lines_to_injectors", "id": "fuel_lines_to_injectors", "children": [{ "name": "fuel_lines_to_injectors", "id": "fuel_lines_to_injectors", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, 
    //       { "name": "fuel pump", "id": "fuel pump", "children": [{ "name": "fuel pump", "id": "fuel pump", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, 
    //     { "name": "fuel_line_to_injector_pump", "id": "fuel_line_to_injector_pump", "children": [{ "name": "fuel_line_to_injector_pump", "id": "fuel_line_to_injector_pump", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "hot_water_out", "id": "hot_water_out", "children": [{ "name": "hot_water_out", "id": "hot_water_out", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "hot_water_to_rad", "id": "hot_water_to_rad", "children": [{ "name": "hot_water_to_rad", "id": "hot_water_to_rad", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "intercooler", "id": "intercooler", "children": [{ "name": "intercooler", "id": "intercooler", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "intercooler_cold", "id": "intercooler_cold", "children": [{ "name": "intercooler_cold", "id": "intercooler_cold", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "intercooler_hot", "id": "intercooler_hot", "children": [{ "name": "intercooler_hot", "id": "intercooler_hot", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "intercooler_rad", "id": "intercooler_rad", "children": [{ "name": "intercooler_rad", "id": "intercooler_rad", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "oil pan", "id": "oil pan", "children": [{ "name": "dip_stick", "id": "dip_stick", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "oilpan_gasket", "id": "oilpan_gasket", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "oil pan", "id": "oil pan", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "panel_frame", "id": "panel_frame", "children": [{ "name": "panel_frame", "id": "panel_frame", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "rad_frame", "id": "rad_frame", "children": [{ "name": "rad_frame", "id": "rad_frame", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "starter_motor", "id": "starter_motor", "children": [{ "name": "battery", "id": "battery", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "engine_alternator", "id": "engine_alternator", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "wiring", "id": "wiring", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "starter_motor", "id": "starter_motor", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "turbocharger", "id": "turbocharger", "children": [{ "name": "exhaust manifold", "id": "exhaust manifold", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "turbocharger", "id": "turbocharger", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "water_pump", "id": "water_pump", "children": [{ "name": "cold_water_in", "id": "cold_water_in", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "water_pump", "id": "water_pump", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }]
    //console.log("this.shipCompsCntls", this.shipCompsCntls);
    this.bckupShip_comp_ctl_list = JSON.stringify(this.shipCompsCntls);
    // this.broadcastInfo({ src: 'main', event: 'shipCompsCntls', data: this.shipCompsCntls });
  }
  cameraGroup = []
  children = {};
  dbobj = {};
  dbchildobj = {};
  oilanim_objs=[];
  deconstructShip() {
    this.stopSceneAnim();
    this.replaceMats();
    let dfx = this.datauxview.getDatascape();
    let ship = this.datauxview.getElementId('imodel');
    let mesh = dfx.getElementMesh(ship);
    mesh.getChildren().forEach((m) => {
      if(!m.getBoundingInfo){
        return;
      }
      if (!m.isPickable) {
        m.isPickable = true;
      }
      
      let mid = this.getMeshID(m);
      this.shipComps.push(mid);
      let _rot = m.rotationQuaternion ? m.rotationQuaternion.toEulerAngles() : m.rotation;
      let _ce = this.getParentElemBound(m);
     // console.log("materialalb",m)
      if(m.material){
        this.compDefPos[mid] = { bound: _ce, color: m.material.albedoColor, position: { x: m.position.x, y: m.position.y, z: m.position.z }, rot: { x: _rot.x, y: _rot.y, z: _rot.z }, qrot: m.rotationQuaternion, scale: m.scaling }
      }
     
      m.isVisible = false;
      m.setEnabled(false);
    })
    let children = [];
    this.shipComps.forEach((c) => {
      let comp = this.datauxview.getElementId(c);
      let geometry = this.compDefPos[c];
      //console.log("geometry",geometry,comp,c)
      if (!comp) return;
      dfx.modify(comp, { geometry: { position: geometry.position } })
      children.push(comp);
      let pos = { x: geometry.position.x, y: geometry.position.y, z: geometry.position.z };
      this.children[c] = { pos }
      let hmesh = dfx.getElementMesh(comp);
      if (!this.dbobj[c]) {
        this.dbobj[c] = [, hmesh];
      }
      hmesh.rotationQuaternion = null;
      hmesh.rotation.x = geometry.rot.x;
      hmesh.rotation.y = geometry.rot.y;
      hmesh.rotation.z = geometry.rot.z;
      hmesh.scaling = geometry.scale;
      /*  let nm = hmesh.material&&hmesh.material.name;
       if(this.mtls[nm]){
         hmesh.material=this.mtls[nm];
       } */
      dfx.setElementTransition(comp, 0);
    })
    dfx.setAsParent(ship, children);
    //dfx.setElementScale(ship, [40, 40, 40]);
    this.shipElems = [].concat(this.sensors, this.cameras, this.shipComps);
    mesh.isVisible = false;

    this.deconstructChildShip(mesh);
    /**
     * patch for IDG model animation issue on adding children mesh
     */
     this.dbobj["crankshaft"][1].rotation.z=0;
    this.applyParentChild();
    if (this.testMode == 'assemble-parts') {
      this.getQuestion();
    }
    this.excludeRHIBLighting(mesh);
    this.initEngineAnim();
  }

  deconstructChildShip(pmesh) {
    pmesh.getChildren().forEach((m) => {
      let dfx = this.datauxview.getDatascape();
      let shipChildComps = [];
      m.getChildren().forEach((cmesh) => {
        if(!cmesh.getBoundingInfo){
          return;
        }
        if (!cmesh.isPickable) {
          cmesh.isPickable = true;
        }
        let cid = this.getMeshID(cmesh);
        let comp = this.datauxview.getElementId(cid);
        if (!comp) return;
        shipChildComps.push(cid);
        let _rot = cmesh.rotationQuaternion ? cmesh.rotationQuaternion.toEulerAngles() : cmesh.rotation;
        let _ce = this.getParentElemBound(cmesh);
        this.compDefPos[cid] = { bound: _ce, color: cmesh.material.albedoColor, position: { x: cmesh.position.x, y: cmesh.position.y, z: cmesh.position.z }, rot: { x: _rot.x, y: _rot.y, z: _rot.z }, qrot: cmesh.rotationQuaternion, scale: cmesh.scaling }
        cmesh.isVisible = false;
        cmesh.setEnabled(false);
      })

      let children = [];
      shipChildComps.forEach((c) => {
        let comp = this.datauxview.getElementId(c);
        if (!comp) return;
        let geometry = this.compDefPos[c];
        dfx.modify(comp, { geometry: { position: geometry.position } })
        children.push(comp);
        let pos = { x: geometry.position.x, y: geometry.position.y, z: geometry.position.z };
        this.children[c] = { pos }
        let hmesh = dfx.getElementMesh(comp);
        if (!this.dbchildobj[c]) {
          this.dbchildobj[c] = [, hmesh];
        }
        hmesh.rotationQuaternion = null;
        hmesh.rotation.x = geometry.rot.x;
        hmesh.rotation.y = geometry.rot.y;
        hmesh.rotation.z = geometry.rot.z;
        hmesh.scaling = geometry.scale;
        dfx.setElementTransition(comp, 0);
      });
    });
    this.deconstructThirdLevelShip(pmesh);
  }

  deconstructThirdLevelShip(pmesh) {
    let shipChildComps = [];
    let dfx = this.datauxview.getDatascape();
    pmesh.getChildren().forEach((cmesh) => {
      cmesh.getChildren().forEach((mesh) => {
        mesh.getChildren().forEach((m) => {
          if(!m.getBoundingInfo){
            return;
          }
          if (!m.isPickable) {
            m.isPickable = true;
          }
          let cid = this.getMeshID(m);
          let comp = this.datauxview.getElementId(cid);
          if (!comp) return;
          shipChildComps.push(cid);
          let _rot = m.rotationQuaternion ? m.rotationQuaternion.toEulerAngles() : m.rotation;
          let _ce = this.getParentElemBound(m);

          this.compDefPos[cid] = { bound: _ce, color: m.material.albedoColor, position: { x: m.position.x, y: m.position.y, z: m.position.z }, rot: { x: _rot.x, y: _rot.y, z: _rot.z }, qrot: m.rotationQuaternion, scale: m.scaling }
          m.isVisible = false;
          m.setEnabled(false);
        })

        let children = [];
        shipChildComps.forEach((c) => {
          let comp = this.datauxview.getElementId(c);
          if (!comp) return;
          let geometry = this.compDefPos[c];
          dfx.modify(comp, { geometry: { position: geometry.position } })
          children.push(comp);
          let pos = { x: geometry.position.x, y: geometry.position.y, z: geometry.position.z };
          this.children[c] = { pos }
          let hmesh = dfx.getElementMesh(comp);
          if (!this.dbchildobj[c]) {
            this.dbchildobj[c] = [, hmesh];
          }
          hmesh.rotationQuaternion = null;
          hmesh.rotation.x = geometry.rot.x;
          hmesh.rotation.y = geometry.rot.y;
          hmesh.rotation.z = geometry.rot.z;
          hmesh.scaling = geometry.scale;
          dfx.setElementTransition(comp, 0);
        });
      });
    });
  }

  getQuestion() {
    this.quizList = this.shipComps.map(c => {
      let question = { question: '', answer: '', answerStatus: false, position: { x: 0, y: 0, z: 0 } }
      question['question'] = c;
      if (c == 'base_frame') {
        question['answerStatus'] = true;
        question['answer'] = c;
      }
      return question;
    });
    //console.log("quizList ", this.quizList)
  }
  resetCompCtls() {
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((c) => {
        c.focus = false;
        c.opacity = 'solid';
        c.visible = true;
      })
    }
  }
  applyCompProfiles() {
    let dfx = this.datauxview.getDatascape();
    this.shipComps.forEach((c) => {
      let comp = this.datauxview.getElementId(c);
      let info = this.getCtrlData(c);
      let profile = 'regular';
      if (info && info.color) {
        profile = info.profile || this.addNewProfileColor(info.color);
        info.profile = profile;
      }
      if (info && !info.visible) {
        profile = 'invisible'
      }
      if (info && info.opacity == 'transparent') {
        if (profile != 'invisible') {

          if (profile != 'regular') {
            profile = profile + '_transparent'
          } else {
            profile = 'transparent';
          }
        }
      }
      dfx.modify(comp, { profile: 'regular' })
      dfx.modify(comp, { profile })

      if (info.children.length && profile !== 'invisible') {
        this.applyProfileToChildren(info);
      }
    })
  }
  applyProfileToChildren(pinfo) {
    let dfx = this.datauxview.getDatascape();
    pinfo.children.forEach((c) => {
      let comp = this.datauxview.getElementId(c);
      let info = this.getCtrlData(c);
      let profile = 'regular';
      if (info && info.color) {
        profile = info.profile || this.addNewProfileColor(info.color);
        info.profile = profile;
      }
      if (this.viewObjectMode === "texture") {
        profile = "regular";
      }
      if (info && pinfo.opacity == 'transparent') {
        if (pinfo.profile != 'invisible') {

          if (pinfo.profile != 'regular') {
            profile = 'transparent'
          } else {
            profile = 'transparent';
          }
        }
      }
      dfx.modify(comp, { profile: 'regular' })
      dfx.modify(comp, { profile })
    })
  }
  land_mtl
  scene
  setVenueLightIntensity(i = 4) {
    let lights = this.scene.lights;
    lights.forEach((light) => {
      light.intensity = i;
    })
  }
  addEnv() {
    //this.setVenueLightIntensity(2.25);
    //this.sky = this.dfx.addSky('sky', { size: 30000, rayleigh: 1, inclination: 0.1 });
    let m = this.datauxview.getElementId("land");
    let mesh = this.dfx.getElementMesh(m);
    let glass_mtl = this.scene.getMaterialByID("glass_mtl");
    let glass_mtl2 = this.dfx.getStandardMaterial("glass_mtl2");
    let tex = glass_mtl.diffuseTexture;//dfx.getTexture("/assets/rov/assets/base.png");
    glass_mtl2.diffuseColor.r = 0.15;
    glass_mtl2.diffuseColor.g = 0.15;
    glass_mtl2.diffuseColor.b = 0.15;
    glass_mtl2.opacityTexture = tex;
    glass_mtl2.opacityTexture.getAlphaFromRGB = true;
    mesh.material = glass_mtl2;
    this.land_mtl = glass_mtl2;
    mesh.isPickable = false;
  }
  applylandMtl() {
    let dfx = this.datauxview.getDatascape();
    let m = this.datauxview.getElementId("land");
    let mesh = dfx.getElementMesh(m);
    mesh.material = this.land_mtl;
  }
  showHideLand(boo) {
    let dfx = this.datauxview.getDatascape();
    let m = this.datauxview.getElementId("land");
    let mesh = dfx.getElementMesh(m);
    mesh.isVisible = boo;
  }
  lightIntensity_solid() {
    let dfx = this.datauxview.getDatascape();
    let scene = dfx.getCamera().getScene();
    let lights = scene.lights;
    lights[0].intensity = 1.25;
    lights[1].intensity = 1.25;
  }
  lightIntensity_tex() {
    let dfx = this.datauxview.getDatascape();
    let scene = dfx.getCamera().getScene();
    let lights = scene.lights;
    lights[0].intensity = 1;
    lights[1].intensity = 1;
  }

  /* * *
  * method for init objects
  * * */
  dfx
  initObjects() {
    this.showLoading = true;
    window.scope = this;
    // load all the assets to be used information from socket
    this.datauxview.loadAssets('objects', 'json', (objectstatus) => {
      if (objectstatus) {
        this.datauxview.renderAssets('objects', 'json', (objectstatus) => {
          if (objectstatus) {
            this.dfx = this.datauxview.getDatascape();
            this.scene = this.dfx.getCamera().getScene();
            
            this.stopSceneAnim();
            this.ctrlServ.init(this.datauxview);
            this.addEnv();
            //window.objdef=this.getObjDef()                    
            this.setShipCompsCntls();           
            this.deconstructShip();
            this.initExplodeMesh();
            this.labelBoxCreate();
            this.processModel();
            this.initCanvas();
            this.removeLoader();
            this.deconstructEngine();
            this.initAnimateOilFlow();
            if (window.innerWidth < 1024) {
              this.getDatascape().moveCamera({ distance: 15 });
            }
            this.isAppLoaded = true;
            if (this.testMode === '') {
              this.showDrawerPanel = true;
            }
            setTimeout(() => {
              // this.getObjDefJSON();
              this.showExternalTools = true;
              this.showLoading = false;
              this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
            }, 1000);
          }
        }, () => { })
      }
    });
  }
  deconstructEngine() {
    let dfx = this.datauxview.getDatascape();
    var engine = this.getMesh('imodel')
    engine.getChildMeshes().forEach((m) => {
      if (!m.isPickable) {
        m.isPickable = true;
      }
      let mid = this.getMeshID(m);
      let hmesh = m;
      if (!this.dbobjEngineAnimation[mid]) {
        this.dbobjEngineAnimation[mid] = [, hmesh];
      }
      this.engineAnimationPostion[mid] = { position: { x: m.position.x, y: m.position.y, z: m.position.z } }
    })
  }

  labelBoxCreate() {
    var boxList = Object.keys(this.compDefPos);
    boxList.forEach(e => {
      this.hitPosition = this.compDefPos[e].bound[0];
      this.createLabelObject('cube', this.hitPosition, e);
    })
  }
  addCompTargets() {
    if (Object.keys(this.comp_target_arr).length) {
      return;
    }
    this.shipComps.forEach((c) => {
      if (this.compTargets.includes(c)) {
        let comp = this.datauxview.getElementId(c);
        this.createCompTarget(c, comp);
      }
    });
    this.animatorService.init(this.datauxview, this.comp_target_arr, this.spheremodel);
    this.animatorService.broadcastObs.subscribe(obj => {
      this.targetClicked = true;
      setTimeout(() => {
        this.targetClicked = !true;
      }, 750)
      if (obj.type === 'broadcast') {
        if (obj.value.key === 'CH148') {
          obj.value.sub = this.heli_path_mode;
        }
        if (obj.value.key.includes("RHIB")) {
          obj.value.key = "RHIB";
        }
        if (obj.value.key === 'Smart_S_Radar') {
          if (obj.value.state == 'stop') {
            obj.value.sub = "scan";
            this.triggerDemoAnim({ event: "demo_anim", name: "Smart_S_Radar", state: "stop", data: "scan" })
          }
        }
        obj.value.src = 'main';
        obj.value.event = 'updatectrl'
        this.broadcastInfo(obj.value);
      }
      if (obj.type === 'action') {
        if (obj.prop === 'showhide') {

        }
      }
      if (obj.type === 'vars') {
        this[obj.prop] = obj.value;
      }
      if (obj.type === 'func') {
        this[obj.prop](obj.value);
      }
      if (obj.type === 'updateCtrlData') {
        let info = this.getCtrlData(obj.value[0]);

        if (obj.value[0] === "Smart_S_Radar" && obj.prop == 'playing' && info[obj.prop] !== obj.value[1]) {
          /* if (this.compAnimStatus === 'playing') {
            this.showHideRadarBeam(obj.value[1])
          } else if (this.compAnimStatus === 'paused' && !obj.value[1]) {
            this.showHideRadarBeam(obj.value[1])
          } */
        }
        info[obj.prop] = obj.value[1]
      }
    })
    Object.keys(this.comp_target_arr).forEach((t) => {
      let comp = this.comp_target_arr[t][1];
      this.animatorService.attach(comp)
    })
  }

  /**
  * sample code to load the application venue using different data source
  */
  ngAfterViewInit(): void {
    // load all the canvas settings from settings json file
    //this.datauxview.setJSONPath(project.config.JsonPath);
    // if(!this.testModePopup){
    this.configService.loadFile('../assets/license.info').then((info) => {
      this.configService.getProjectConfig().then((project_config: any) => {
        project_config.licence = info;
        this.datauxview.setProjectSettins(project_config);
        this.datauxview.loadCanvas('settings', 'json', (data, settingstatus) => {
          var setting_status = settingstatus;
          this.datauxview.yaw_3d = this.datauxview.yaw_2d = 270;
          this.datauxview.pitch_2d = 15
          if (!setting_status) {
            setting_status = this.attachDynamicObject(data, (settingstatus) => {
              if (settingstatus) {
                this.initObjects();
              }
            });
          } else {
            this.initObjects();
          }
          setTimeout(() => {
            this.pickleftAttach();
            this.styleLength = document.head.getElementsByTagName('style').length;
          }, 2000);

        });
      }, (err) => { _console.log(err) });
    }, (err) => { alert("License not found!") });
    // }

  }
  track_label_tex = {
    "meshes": [{
      "position": [0, 0, 0],
      "rotation": [0, 0, 0],
      "scaling": [1, 1, 1],
      "isVisible": true,
      "isEnabled": true,
      "checkCollisions": false,
      "alphaIndex": 201,
      "billboardMode": 0,
      "receiveShadows": false,
      "name": "track",
      "id": "track",
      "positions": [],
      "normals": [],
      "uvs": [],
      "indices": []
    }]
  };

  attachDynamicObject(data, callback) {
    var _this = this;
    const TERMINAL_ORIGIN = [-97.35, 33];
    this.shapeCreatorService = new ShapeCreatorService(TERMINAL_ORIGIN[0], TERMINAL_ORIGIN[1]);
    var trackWidth_met = 4;
    let trackgeom = _this.shapeCreatorService.MakeColourRect(1000, trackWidth_met, 32.0 / 1024.0, 1 - (828.0 / 1024.0));
    let _track = JSON.parse(JSON.stringify(_this.track_label_tex));
    let track = _track.meshes[0];
    track.name = track.name;
    track.id = track.name;
    track.positions = trackgeom.positions;
    track.normals = trackgeom.normals;
    track.uvs = trackgeom.uvs;
    track.indices = trackgeom.indices;
    data.shapes[track.name] = 'data:' + JSON.stringify(_track);
    return _this.datauxview.attachDynamicObject(data, callback);
  }
  demomode = false;
  lastdata = null;
  _wireframemode = null;


  /**
  * Methods specific to position and control components
  */

  /**
  * creating a key event to show/hide positioning tool
  */
  @HostListener('document:keydown', ['$event'])
  handleKeyboardDownEvent(event: KeyboardEvent) {

    this.altKey = event.altKey;
  }
  @HostListener('document:keyup', ['$event'])
  handleKeyboardUpEvent(event: KeyboardEvent) {
    const key = event.key.toString().toLowerCase();
    this.altKey = false;
    if (event.shiftKey && key === 't') {
      this.controlPanelState = true;
    }
    if (((key === 'v') && event.shiftKey === true)) {
      this.positiontool = !this.positiontool;
    } else if (((key === 's') && event.shiftKey === true)) {
      /* if (!this.socketcontroler) {
        this.positiontoolcomponent.opencontant((result) => {
          this.socketcontroler = result;
        });
      } else {
        this.positiontoolcomponent.closecontant();
        this.socketcontroler = false;
      } */
    }
  }

  /**
  * Zoom event to zoom in / out the venue
  */
  isMouseDown
  mousestate = "up"
  Zoom(key) {
    this.isMouseDown = true;
    this.datauxview.startZoom(key);
  }
  stopZoom() {
    this.isMouseDown = !true;
    this.datauxview.stopZoom();
  }
  @HostListener('document:mousepress', ['$event'])
  handleMouseDownEvent(event: MouseEvent) {
    this.mousestate = "down";
    if (this.onHoverElem) {
      this.offHover(this.onHoverElem);
    }
  }
  @HostListener('document:mouseup', ['$event'])
  handleMouseUpEvent(event: MouseEvent) {
    if (this.isMouseDown) {
      this.targetClicked = true;
      this.stopZoom();
    }
    this.isMouseDown = !true;
    this.mousestate = "up";
    if (this.onHoverElem) {
      this.offHover(this.onHoverElem);
    }
    //this.informCanvasOfMouseUp();
    setTimeout(() => {
      this.targetClicked = !true;
    }, 750)
  }
  getSensorParent(sens) {
  }

  /**
  * Sensor Hide/ Show
  */
  sensorTargetOff = false;
  cameraTargetOff = false;
  compTargetOff = false;
  targetHideShow(e) {
    this.compTargetOff = !e;
    this.animatorService.setTagStatus('compTargetOff', this.compTargetOff);
    if (!this.multipleTagStatus) {
      if (this.disableTrans) {
        this.showHideCompTargets(false);
      } else {
        this.showHideCompTargets(e);
      }
    }
  }
  sensorHideShow(e, hideSens = false) {
    // _console.log(e);
    // let allObject = this.datauxview.allObjects();
    // let allObjKeys = Object.keys(allObject);
    this.sensorTargetOff = !e;
    this.shipSmartSensor.forEach((element, i) => {
      var object: any = element.target.split('_');
      let parent_data = null;
      let eboo = e;
      if (object[0] == 'sensor') {
        let datascape = this.datauxview.getDatascape();
        let target = this.datauxview.getElementId(element.target);
        let sensor = this.datauxview.getElementId(element.id);
        let domodify = true;
        if (this.disableTrans) {
          let props = datascape.props(sensor);
          domodify = props.profile.visible;
          this.shipCompFocusStatus();
          // if (!this.shipCompFocusState) {
          //   domodify =
          // }
          let idx = this.shipCompFocusElem.sensors.findIndex(e => e == element.id)
          if (idx > -1) {
            domodify = true;
          }
        } else {
          parent_data = this.getCtrlData(element.id, 'sensors', 'contains');
          if (parent_data) {
            let parent = this.datauxview.getElementId(parent_data.id);
            let props_p = datascape.props(parent);
            domodify = props_p.profile.visible;
          }
        }
        if (domodify) {
          if (parent_data) {
            if (!parent_data.selected) {
              eboo = false;
            }
          }
          if (eboo) {
            datascape.modify(target, { profile: 'regular' })
            datascape.modify(sensor, { profile: 'regular' })
          } else {
            datascape.modify(target, { profile: 'invisible' })
            datascape.modify(sensor, { profile: 'invisible' })
          }
          if (hideSens || eboo) {
            if (eboo) {
              datascape.modify(sensor, { profile: 'regular' })
            } else {
              datascape.modify(sensor, { profile: 'invisible' })
            }
          }
        }
      }
    });
  }

  /**
  * Camera Hide/ Show
  */
  cameraHideShow(e, hidecam = false) {
    // _console.log(e);
    // let allObject = this.datauxview.allObjects();
    // let allObjKeys = Object.keys(allObject);
    this.cameraTargetOff = !e;
    this.shipCameras.forEach((element, i) => {
      var object: any = element.target.split('_');
      if (object[0] == 'camera') {
        let datascape = this.datauxview.getDatascape();
        let target = this.datauxview.getElementId(element.target);
        let camera = this.datauxview.getElementId(element.id);
        let domodify = true;
        if (this.disableTrans) {
          let props = datascape.props(camera);
          domodify = props.profile.visible;
        } else {
          let parent_data = this.getCtrlData(element.id, 'sensors', 'contains');
          if (parent_data) {
            let parent = this.datauxview.getElementId(parent_data.id);
            let props_p = datascape.props(parent);
            domodify = props_p.profile.visible;
          }
        }
        if (domodify) {
          if (e) {
            datascape.modify(target, { profile: 'regular' })
          } else {
            datascape.modify(target, { profile: 'invisible' })
          }
          if (hidecam || e) {

            // _console.log("camera", element, e);
            if (e) {
              datascape.modify(camera, { profile: 'regular' })
            } else {
              datascape.modify(camera, { profile: 'invisible' })
            }
          }
        }
      }
      // if (object[1] == 'RIM162ESSM1') {
      //   let datascape = this.datauxview.getDatascape();
      //   let camera = this.datauxview.getElementId(element);
      //   // _console.log("camera", element, e);
      //   if (e) {
      //     datascape.modify(camera, { profile: 'regular' })
      //   } else {
      //     datascape.modify(camera, { profile: 'invisible' })
      //   }
      // }
    });
  }
  /**
  * Camera Position event to move the camera to different view / angle
  */
  viewMode = 'solid';
  viewObjectMode = 'solid';
  camviews = {
    "idg": {
      "home": { "target": { "x": 0.3, "y": 0.86, "z": -0.3 }, "distance": 10, "yaw": 300, "pitch": 27.85 },
      "top": { "target": { "x": 0.3, "y": 0.86, "z": -0.3 }, "distance": 10, "yaw": 270, "pitch": 89.9 },
      "left": { "target": { "x": 0.3, "y": 0.86, "z": -0.3 }, "distance": 10, "yaw": 0.09, "pitch": 27.85 },
      "right": { "target": { "x": 0.3, "y": 0.86, "z": -0.3 }, "distance": 10, "yaw": 179.9, "pitch": 27.85 },
      "back": { "target": { "x": 0.3, "y": 0.86, "z": -0.3 }, "distance": 10, "yaw": 89.9, "pitch": 27.85 },
      "front": { "target": { "x": 0.3, "y": 0.86, "z": -0.3 }, "distance": 10, "yaw": 269.9, "pitch": 27.85 },
    },
    "inexxt": {
      "home": { "target": { "x": 35.4138, "y": 3, "z": -30.8376 }, "distance": 560, "yaw": 160, "pitch": 27.85 },
      "top": { "target": { "x": 35.4138, "y": 3, "z": -30.8376 }, "distance": 560, "yaw": 190, "pitch": 89.9 },
      "left": { "target": { "x": 35.4138, "y": 3, "z": -30.8376 }, "distance": 560, "yaw": -70, "pitch": 27.85 },
      "right": { "target": { "x": 35.4138, "y": 3, "z": -30.8376 }, "distance": 560, "yaw": 100, "pitch": 27.85 },
      "back": { "target": { "x": 35.4138, "y": 3, "z": -30.8376 }, "distance": 560, "yaw": 20, "pitch": 27.85 },
      "front": { "target": { "x": 35.4138, "y": 3, "z": -30.8376 }, "distance": 560, "yaw": 190, "pitch": 27.85 },
      "idg-focus": { "target": { "x": 10.64960, "y": 3, "z": -25.0223 }, "distance": 150, "yaw": 125, "pitch": 27.85 },
    },
    "quiz": {
      "quiz-home": { "target": { "x": 0.4, "y": 0.86, "z": 0.6 }, "distance": 10, "yaw": 300, "pitch": 27.85 },
      "quiz-top": { "target": { "x": 0, "y": 0.86, "z": 0.6 }, "distance": 10, "yaw": 270, "pitch": 89.9 },
      "quiz-left": { "target": { "x": 1, "y": 0.86, "z": -0.8 }, "distance": 10, "yaw": 0.09, "pitch": 27.85 },
      "quiz-right": { "target": { "x": -1, "y": 0.86, "z": -0.5 }, "distance": 10, "yaw": 179.9, "pitch": 27.85 },
      "quiz-back": { "target": { "x": 0.4, "y": 0.86, "z": -1.6 }, "distance": 10, "yaw": 89.9, "pitch": 27.85 },
      "quiz-front": { "target": { "x": 0.4, "y": 0.86, "z": 0.6 }, "distance": 10, "yaw": 269.9, "pitch": 27.85 },
    },
    'engine-Amination': {
      "home": {
        "target": { "x": 0.3, "y": 0.86, "z": -0.3}, "distance": 10, "yaw": 300, "pitch": 27.85 
      }
    }
  }

  changeCamView(v, vobj = false) {
    let felem = this.getFocusElem();
    let target = { "x": 0.3, "y": 0.86, "z": -0.3 }
    let distance = 125;
    if (felem) {
      let el = this.datauxview.getElementId(felem)
      target = this.getElemCenter(el)
      distance = undefined;
    }
    let view;
    if (this.testMode === "quiz") {
      let camviews = this.camviews['quiz'];
      view = vobj ? v : camviews[v];
    } else {
      let camviews;
      if (this.engineAnimationMode) {
        v = "home";
        camviews = this.camviews["engine-Amination"];
      } else {
        camviews = this.camviews[this.activeModel];
      }
      view = vobj ? v : camviews?camviews[v]:"home";
    }
    // view.target = target;
    // view.distance = distance;
    this.moveCameraTo(null, view)
  }
  setOperationMode() {
    //this.saveState();
    if (this.disableTrans) {
      this.closeSubSystemView();
    }
    //this.broadcastInfo({ src: 'main', event: 'savestate', key: "", state: true, sub: "" });
    //this.broadcastInfo({ src: 'main', event: 'showall', key: "", state: true, sub: "" });
    // this.removeDrag("null", true);
    //this.resetChildren();
    this.operationMode = true;
  }
  setInspectMode() {
    //this.loadState();
    //this.broadcastInfo({ src: 'main', event: 'loadstate', key: "", state: true, sub: "" });
    /* if(this.dragMode){
      this.reapplyDrag();
    } */
    this.operationMode = false;
  }
  viewElement(x, state) {
    this.removeDrag("null", true);
    this.shipComps.forEach((comp) => {
      let info = this.getCtrlData(comp);
      if (!info.isSub) {
        return;
      }
      if (state) {
        if (comp == x) {
          this.solidTransElem(comp, true);
        } else {
          this.solidTransElem(comp, false);
        }
      } else {
        this.solidTransElem(comp, true);
      }
    });
    this.reapplyDrag();
  }
  dragMode = false;
  operationMode = false;
  onChangeCameraPosition(camView) {
    this.viewObjectMode = camView;
    if (camView === 'explode') {
      this.showHideLand(false);
      this.explodeMesh()
    }
    if (camView == 'drag') {
      if (this.engineAnimationMode) {
        if (this.dragModeAnimation) {
          this.enableDragEngine();
        } else {
          this.removeDragEngine();
        }
      } else {
        this.dragMode = !this.dragMode;
        if (!this.dragMode) {
          this.removeDrag("null", true);
        } else {
          this.removeDrag("null", true);
          this.reapplyDrag();
        }
      }
      return
    }
    if (camView == 'control') {
      this.setOperationMode()
      return
    }
    if (camView == 'inspect') {
      this.setInspectMode()
      return
    }
    if (camView == 'drag_reset') {
      if (this.engineAnimationMode) {
        var engine = this.getMesh('imodel');
        let dfx = this.datauxview.getDatascape();
        engine.getChildMeshes().forEach((m) => {
          this.resetChildEngine(m)
        })
      } else {
        if (this.focusMode) {
          this.resetChildCompDrag();
        } else {
          if (this.testMode == 'quiz') {
            this.changeCamView('quiz-home');
          } else {
            if (this.mesh_explode) {
              this.resetMeshExplode();
              this.mesh_explode = false;
            } else {
              this.resetChildren();
            }
            this.onChangeCameraPosition('home');
          }
        }
      }



      return
    }
    if (camView === 'dock') {
      //this.toggleDock(!this.docked);
      return
    }
    if (camView === 'water') {
      this.toggleOcean();
      return
    }
    if (camView === 'wireframe') {
      let f = this.getFocusElem();
      if (this.viewMode == camView) {
        return
      }
      //this.viewMode = camView
      this.wireFrameMode(true)
      this.cameraHideShow(false, true);
      this.sensorHideShow(false, true);
      this.targetHideShow(false);
      //this.viewMode = camView;
      return
    }
    if (camView === 'solid') {
      if (this.viewMode == camView) {
        return
      }
      this.textureMode(camView);
      this.cameraHideShow(true);
      this.sensorHideShow(true);
      this.targetHideShow(true);
      return
    }
    if (camView === 'texture') {
      if (this.viewMode == camView) {
        return
      }
      this.textureMode(camView);
      this.cameraHideShow(true);
      this.sensorHideShow(true);
      this.targetHideShow(true);
      return
    }
    if (camView === 'play_anim') {
      this.startAnimation()
    }
    if ((camView == 'left' || camView == 'right' || camView == 'back' || camView == 'back' || camView == 'top' || camView == 'front')) {
      if (this.testMode == 'quiz') {
        this.changeCamView('quiz-' + camView);
      } else {
        this.changeCamView(camView);
      }
      return;
    }
    if (camView === 'home') {
      // if (this.lastCamState) {
      if (this.testMode == 'quiz') {
        this.changeCamView('quiz-home');
      } else {
        this.changeCamView('home', false);
      }
      //   return;
      // }
    }
    if (this.cam_mode == '2D' && (camView == 'left' || camView == 'right' || camView == 'back')) {
      camView = 'ortho' + camView
    } else {
    }
    // this.datauxview.Camera(camView);
  }
  cam_mode = '3D'
  onChangeCameraMode(camView) {
    this.cam_mode = camView;
    this.datauxview.CameraMode(camView);
    if (camView == '3D') {
      setTimeout(() => {
        if (this.testMode == 'quiz') {
          this.changeCamView('quiz-home');
        } else {
          this.changeCamView('home', false);
        }
      }, 1500);
    }
  }

  drag = false;
  addDragAndDrop(id) {
    _console.log("addDragAndDrop :", id);
    if (!this.drag) {
      var behavior = this.datauxview.getDatascape().addDrag(this.datauxview.getElementId(id));
      this.drag = true;
    } else {
      this.datauxview.getDatascape().removeDrag(this.datauxview.getElementId(id), behavior);
      this.drag = false;
    }
  }
  docked = false;
  hasWater = true;
  getDockBuildings() {
    let dfx = this.getDatascape();
    let elem = this.datauxview.getElementId('halifax_dock');
    let mesh = dfx.getElementMesh(elem);
    let meshes = mesh.getChildMeshes();
    meshes.forEach((m) => {
      if (m.name.includes("building")) {
        this.allMeshes.push([m.name, m]);
      }
    })
  }
  toggleDock(boo = null) {
    let dfx = this.getDatascape();
    let elem = this.datauxview.getElementId('halifax_dock');
    if (boo !== null) {
      this.docked = boo;
    }
    if (this.docked) {
      dfx.modify(elem, { profile: "regular" })
    } else {
      dfx.modify(elem, { profile: "invisible" })
    }
    this.animatorService.docked = this.docked;
    if (this.docked) {
      this.animatorService.stopAnim("RHIB_1_arm")
      this.animatorService.stopAnim("RHIB_2_arm")
    }
    this.broadcastInfo({ src: 'main', event: 'updatectrl', key: "RHIB", state: this.docked, sub: "dock" });
  }
  toggleOcean(boo = null) {
    let dfx = this.getDatascape();
    let elem = this.datauxview.getElementId('land');
    this.hasWater = !this.hasWater;
    if (boo !== null) {
      this.hasWater = boo;
    }
    if (this.hasWater) {
      //dfx.modify(elem, { profile: "regular" })
      this.showHideLand(true);
    } else {
      //dfx.modify(elem, { profile: "invisible" })
      this.showHideLand(!true);
    }
  }
  addTextures() {
    let datascape = this.datauxview.getDatascape();
    //let ship=this.datauxview.getElementId('ship');
    //let land = this.datauxview.getElementId('land');
    let ship_profile = {
      texture: {
        material: 'ship_mtl',
        transition: 1000,   // in milliseconds
        visible: true,
        shadow: true,
        selectable: true,
        wireframe: false

      }
    }
    let land_profile = {
      texture: {
        material: 'water_mtl',
        transition: 1000,   // in milliseconds
        visible: true,
        wireframe: false

      }
    }
    // datascape.addProfiles(ship,ship_profile)
    //datascape.addProfiles(land, land_profile)
  }

  _alreadyinframe: any;
  env_black = { r: 0.85, g: 0.85, b: 0.85, a: 1 };
  env_sky = { r: 0.65, g: 0.65, b: 0.65, a: 1 };
  env_black_a = { r: 0.85, g: 0.85, b: 0.85, a: 1 };
  envID
  animEnv() {
    let m = this.env_sky.r - this.env_black.r;
    let time = 100;
    let dm = m / time;
    let r = this.env_black_a.r;
    let g = this.env_black_a.g;
    let b = this.env_black_a.b;
    let datascape = this.datauxview.getDatascape();
    let scene = datascape.getCamera().getScene();
    let land = this.datauxview.getElementId('land');
    if (this.envID) {
      //this.stopEnvAnim();
      return;
    }
    //datascape.modify(land, { profile: 'invisible' })
    this.showHideLand(!true);
    this.envID = setInterval(() => {
      r = r + dm;
      g = g + dm;
      b = b + dm;
      scene.clearColor.r = r;
      scene.clearColor.g = g;
      scene.clearColor.b = b;
      this.env_black_a = { r, g, b, a: 1 };
      if (r >= this.env_sky.r) {
        this.stopEnvAnim();
      }
    }, 1)
  }
  stopEnvAnim(reset = false) {
    let datascape = this.datauxview.getDatascape();
    let scene = datascape.getCamera().getScene();
    let land = this.datauxview.getElementId('land');
    clearInterval(this.envID);
    this.envID = null;
    if (reset) {
      scene.clearColor.r = this.env_black.r;
      scene.clearColor.g = this.env_black.g;
      scene.clearColor.b = this.env_black.b;
      this.env_black_a = this.clone(this.env_black);
      // datascape.modify(land, { profile: 'regular' })
      this.showHideLand(true);
    }
  }
  setEnv(col) {
    let datascape = this.datauxview.getDatascape();
    let scene = datascape.getCamera().getScene();
    /* scene.clearColor.r = col.r;
    scene.clearColor.g = col.g;
    scene.clearColor.b = col.b; */
  }
  enableShipEdges() {
    let dfx = this.datauxview.getDatascape();
    let ship = this.datauxview.getElementId('imodel');
    let mesh = dfx.getElementMesh(ship);
    mesh.getChildMeshes().forEach((m) => {
      m.enableEdgesRendering(0.1);
      m.edgesColor.r = 1; m.edgesColor.g = 1; m.edgesColor.b = 1;
      m.edgesWidth = 4
      if (m.material) {
        /* m.material.ambientColor.r=0.6;
      m.material.ambientColor.g=0.6;
      m.material.ambientColor.b=0.6; */
      }
    })
    let m = mesh;
    m.enableEdgesRendering(0.9);
    m.edgesColor.r = 1; m.edgesColor.g = 1; m.edgesColor.b = 1;
    m.edgesWidth = 4
  }
  disableShipEdges() {
    let dfx = this.datauxview.getDatascape();
    let ship = this.datauxview.getElementId('imodel');
    let mesh = dfx.getElementMesh(ship);
    mesh.getChildMeshes().forEach((m) => {
      m.disableEdgesRendering();
    })
    mesh.disableEdgesRendering();
  }
  wireFrameMode(boo) {
    let datascape = this.datauxview.getDatascape();
    let scene = datascape.getCamera().getScene();
    if (boo && this.viewMode !== 'solid') {
      this.textureMode('solid', 'wireframe');
      ///this.viewMode = 'wireframe';
    } else if (boo) {
      this.viewMode = 'wireframe';
    }
    scene.forceWireframe = boo;
    //let land = this.datauxview.getElementId('land');
    if (boo) {
      //datascape.modify(land, { profile: 'regular' })
      //this.setEnv(this.env_black)
    }
  }
  textureMode(mode = 'texture', v = null) {
    this.resetTagViewMode();
    this.wireFrameMode(false);
    let datascape = this.datauxview.getDatascape();
    let ship = this.datauxview.getElementId('imodel');
    if (mode == 'solid') {
      this.lightIntensity_solid()
      this.showLoading = true;
      this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
      setTimeout(() => {
        //this.setEnv(this.env_black);
        this.setShipTexture(datascape, ship, 'grey');
        //datascape.modify(land, { profile: 'regular' });
        //this.enableShipEdges();
        this.doreset = true;
        this.resetCompCtls();
        this.applyCompProfiles();

        //this.checkForFocusElem();
        setTimeout(() => {
          this.showLoading = !true;
          this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
        }, 1000);
        this.doreset = false;
        if (v) {
          setTimeout(() => {
            this.viewMode = v
          }, 200)
        } else {
          this.viewMode = mode;
        }

      }, 200)
    }
    if (mode == 'texture') {
      this.stopEnvAnim(true);
      this.resetSolidState();
      // this.lightIntensity_tex()
      this.setShipTexture(datascape, ship);
      this.viewMode = mode;
    }

  }
  getFocusElem() {
    let foc_elem = null;
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((c) => {
        if (c.focus) {
          foc_elem = c.id;
        }
      })
    }
    return foc_elem;
  }
  checkForFocusElem() {
    let foc_elem = this.getFocusElem();
    if (foc_elem) {
      this.focusElem(foc_elem, 'solid');
    }
  }
  getMeshID(m) {
    let aname = m.id.split(".");
    let name = aname[aname.length - 1];
    return name;
  }
  getMeshByID(_id) {
    let dfx = this.datauxview.getDatascape();
    let ship = this.datauxview.getElementId('imodel');
    let mesh = dfx.getElementMesh(ship);
    let id = _id.toLowerCase();
    let meshes = mesh.getChildMeshes();
    let l = meshes.length;
    let i = 0;
    let __mesh = null;
    for (; i < l; i++) {
      let _m = meshes[i];
      let mid = this.getMeshID(_m).toLowerCase();
      if (mid === id) {
        __mesh = _m;
        break;
      }
    }
    return __mesh;
  }
  applyAutoAnim() {
    let dfx = this.getDatascape();
    let arr = [
      { name: "Sea_Giraffe", rpm: 60 },
      { name: "Nav_Radar_1", rpm: 60 },
      { name: "Nav_Radar_2", rpm: 60 },
      { name: "Nav_Radar_3", rpm: 60 },
      { name: "Prop_Rotor_L", rpm: 120 },
      { name: "Prop_Rotor_R", rpm: 120 }
    ]
    arr.forEach((obj) => {
      let propellar = obj.name.includes('Prop_Rotor')
      if (this.docked && propellar) {
        return;
      }
      let comp = this.datauxview.getElementId(obj.name);
      let mesh = dfx.getElementMesh(comp);
      let axis = obj.name.includes('Prop_Rotor') ? 'z' : 'y';
      let rps = (obj.rpm || 10) / 60;
      mesh.rotation[axis] += (2 * Math.PI / 60) * rps;
    })
  }
  rotors_rot: any = {};
  rotors_still: any = {};
  rotors_cur: any = {};
  rotID;
  animID;
  sensorTimerID;
  time = 0;
  rcount = 0;
  heli_path_mode = 1;
  rpm_01 = 250;
  rpm_02 = 250;
  rpm_03 = 250;
  rpm_04 = 250;
  rotateRotors() {
    let dfx = this.datauxview.getDatascape()
    let p01 = this.datauxview.getElementId("Object061");
    let p02 = this.datauxview.getElementId("Object060");
    let p03 = this.datauxview.getElementId("Object059");
    let p04 = this.datauxview.getElementId("Object037");
    let mp01 = dfx.getElementMesh(p01);
    let mp02 = dfx.getElementMesh(p02);
    let mp03 = dfx.getElementMesh(p03);
    let mp04 = dfx.getElementMesh(p04);
    this.rotors_cur.mp01 = mp01;
    this.rotors_cur.mp02 = mp02;
    this.rotors_cur.mp03 = mp03;
    this.rotors_cur.mp04 = mp04;

    let irpm = 0.5
    this.time = irpm;
    let rpm_m = 250 / 60;
    let dt = rpm_m / (60 * 1);
    cancelAnimationFrame(this.rotID);

    let anim = (timestamp) => {
      if (this.animStatus == 'paused') {
        this.rotID = window.requestAnimationFrame(anim);
        return
      }
      let m01 = this.rotors_cur.mp01;
      let m02 = this.rotors_cur.mp02;
      let m03 = this.rotors_cur.mp03;
      let m04 = this.rotors_cur.mp04;
      if (this.animStatus == 'playing' || this.compAnimStatus === 'playing') {
        m01.rotation.x += (2 * Math.PI / 60) * (this.rpm_01 / 60);
        m02.rotation.x += (2 * Math.PI / 60) * (this.rpm_02 / 60);
        m03.rotation.x += (2 * Math.PI / 60) * (this.rpm_03 / 60);
        m04.rotation.x += (2 * Math.PI / 60) * (this.rpm_04 / 60);
      }
      if (this.compAnimStatus === 'playing') {
        // this.applyAutoAnim();
      }
      this.rotID = window.requestAnimationFrame(anim);
    }
    this.rotID = window.requestAnimationFrame(anim);
  }
  stopRotors() {
    cancelAnimationFrame(this.rotID);
  }

  randomIntFromInterval(min, max) { // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  /*
  initSensors(){
    let dfx = this.datauxview.getDatascape();
    let sen = this.datauxview.getElementId('SensorSmartSRadar_1');
    dfx.setElementScale(sen, [1.25, 0.75, 0.5]);
  }
  */
  startSmartSRadar() {
    let sensorcolor_arr = ['#84daf0', 'dbf2b1', 'e6acac', 'dbf2b1', 'eea0d5', 'f6c355'];
    let dfx = this.datauxview.getDatascape();
    let sen = this.datauxview.getElementId('SensorSmartSRadar_1');
    let coloridx = 0;
    let props = dfx.props(sen);
    let pos = props.geometry.position;
    let orientation = props.geometry.orientation;
    _console.log('startSmartSRadar')
    this.sensorTimerID = setInterval(() => {
      this.sensors.forEach(element => {
        coloridx = this.randomIntFromInterval(0, 5);
        this.changeProfileCol(element, sensorcolor_arr[coloridx]);
      });
    }, 1000)
  }

  stopSmartSRadar() {
    _console.log('stopSmartSRadar')
  }

  animStatus: string = "stopped";
  pauseAnim = false;
  compAnimStatus: string = "playing"
  startAnimation() {
    /* if (this.animStatus === 'playing') {
      this.pauseAnim = true;
      this.animStatus = "paused";
    } else if (this.animStatus === 'paused') {
      this.pauseAnim = false;
      this.animStatus = "playing";
    } else {
      this.animStatus = "playing";
      this.rotateRotors();
      //this.startSmartSRadar()
    } */
    if (this.compAnimStatus === 'playing') {
      this.compAnimStatus = "paused";

    } else {
      this.compAnimStatus = 'playing';
    }
  }
  stopAnimation() {
    cancelAnimationFrame(this.animID);
    clearInterval(this.sensorTimerID);
    this.animStatus = "stopped";
  }

  setShipTexture(dfx, ship, matid = 'full_paint') {
    let scene = dfx.getCamera().getScene();
    let mat = scene.getMaterialByID(matid);
    if (!mat && matid.includes("_clone")) {
      let m = matid.split("_clone")[0]
      let _mat = scene.getMaterialByID(m);
      mat = _mat.clone(matid);
    }
    let mesh = dfx.getElementMesh(ship);
    mesh.getChildMeshes().forEach((m) => {
      if (m.isEnabled()) {
        if (matid.includes('full_paint')) {
          let aname = m.id.split(".");
          let name = aname[aname.length - 1]
          if (name == 'CH148' || name == 'main_rotor' || name == 'tail_rotor') {
            if (matid.includes('clone')) {
              m.setEnabled(false);
            } else {
              m.material = scene.getMaterialByID(name);
            }

          } else if (aname.includes('element-CH148')) {
            //m.material = scene.getMaterialByID('CH148');
            if (matid.includes('clone')) {
              m.setEnabled(false);
            } else {
              m.material = scene.getMaterialByID('CH148');
            }
          } else {
            m.material = mat;
          }
        } else {
          m.material = mat
        }
      }
    })
    mesh.material = mat;
  }

  setCameraSettings(demo) {
    let def = { "target": { "x": 0.3, "y": 0.86, "z": -0.3 }, "distance": 400, "yaw": 0, "pitch": 27 }
    if (demo === 'Scene') {
      def.target.x = 4160
      def.target.y = 677;
      def.target.z = 2611;
      def.distance = 7000
      def.yaw = 300;
      def.pitch = 0;
    }
    if (demo === 'Coloured Points') {
      def.target.x = 247
      def.target.y = -3;
      def.target.z = 70;
      def.distance = 75
      def.yaw = 283;
      def.pitch = 17.5;//
    }
    let dfx = this.datauxview.getDatascape();
    dfx.moveCamera(def);
    this.datauxview.cameraview.home = def;
    this.datauxview.cameraview.left.target = def.target;
    this.datauxview.cameraview.right.target = def.target;
    this.datauxview.cameraview.back.target = def.target;
    //
    this.datauxview.cameraview.left.distance = def.distance;
    this.datauxview.cameraview.right.distance = def.distance;
    this.datauxview.cameraview.back.distance = def.distance;
    //let land = this.datauxview.getElementId("land");
    //dfx.modify(land, { geometry: { position: def.target } })
  }
  spheremodel
  addSphereModel() {
    let dfx = this.datauxview.getDatascape();
    let opt = {
      shape: 'sphere',
      id: 'm_sphere',
      size: 1,
      profiles: {
        regular: {
          material: 'grey',
          transition: 0,
          visible: true
        },
        hidden: {
          material: 'grey',
          transition: 0,
          visible: false
        }
      }
    }
    this.spheremodel = dfx.model(opt);
    setTimeout(() => {
      this.addNewProfileColor("#aaaab3", true, "boat_", this.spheremodel);
    }, 100)

  }
  markers = [];
  addMarkers(pos) {
    let dfx = this.datauxview.getDatascape();
    if (!this.spheremodel) {
      this.addSphereModel()
    }
    let id = 'm_' + this.markers.length
    this.markers[this.markers.length] = dfx.add({
      id,
      model: this.spheremodel,
      geometry: { position: { x: pos.x, y: -30, z: pos.z }, size: 1 }
    });
  }
  clearMarkers() {
    let dfx = this.datauxview.getDatascape();
    while (this.markers.length) {
      let m = this.markers.pop();
      dfx.remove(m);
    }
  }
  car_path = [];
  startRec = false;
  car_pos = []
  toggleOnOffClick: any = false;

  @HostListener('document:click', ['$event']) onMouseClick(e) {
    let isCanvas = e.target.nodeName === 'CANVAS';
    if (!this.datauxview.getDatascape()) return;

    _console.log("hit", this.datauxview.getDatascape().getHitPosition());
    if (!this.objDrag && isCanvas) {
      _console.log("hit", this.datauxview.getDatascape().getHitPosition());
      var hitPosition = this.datauxview.getDatascape().getHitPosition();

      if (hitPosition != null && hitPosition.pickedMesh != null) {
        var warship = hitPosition.pickedMesh.name.split('-')[1];
        _console.log("hit", this.datauxview.getDatascape().getHitPosition());
        if (warship == 'element-imodel' && warship == null) {
          if (this.toggleOnOffClick) {
            this.pickElement = false;
          }
        }
      }
    }
    _console.log("hit", this.datauxview.getDatascape().getHitPosition());
    if (!this.startRec) {
      return
    }
    let pos = this.datauxview.getDatascape().getHitPosition();
    let x = pos.pickedPoint.x;
    let z = pos.pickedPoint.z;
    let y = -30
    let obj = { x, y, z };
    this.car_path.push(obj);
    _console.log(JSON.stringify(obj));
    this.addMarkers(obj);
  }
  getElemCenter(el, _mesh = null) {
    let dfx = this.datauxview.getDatascape();
    let mesh = _mesh || dfx.getElementMesh(el);    
    if(typeof mesh.getBoundingInfo === "function"){
      let c = mesh.getBoundingInfo().boundingSphere.centerWorld;
      let target = { x: c.x, y: c.y, z: c.z }
      return target;
    }

  }
  getElemRadius(el, _mesh = null) {
    let dfx = this.datauxview.getDatascape();
    let mesh = _mesh || dfx.getElementMesh(el);
    if(typeof mesh.getBoundingInfo === "function"){
    let c = mesh.getBoundingInfo().boundingSphere.radius;
    return c;
  }
  }
  getElementMaxSize(el) {
    let dfx = this.datauxview.getDatascape();
    let mesh = dfx.getElementMesh(el);
    if(typeof mesh.getBoundingInfo === "function"){
    let size = mesh.getBoundingInfo().boundingBox.extendSizeWorld;
    return size.x > size.z ? size.x : size.z;
    }
  }
  getElementMaxY(el) {
    let dfx = this.datauxview.getDatascape();
    let mesh = dfx.getElementMesh(el);
    if(typeof mesh.getBoundingInfo === "function"){
    let size = mesh.getBoundingInfo().boundingBox.maximumWorld.y;
    return size;
    }
  }
  getParentElemBound(mesh) {
    let meshes = mesh.getChildMeshes();
    let c = this.getElemCenter(null, mesh);
    let r = this.getElemRadius(null, mesh);
    let l = 0
    /* if (meshes.length) {
      let cx = 0;
      let cy = 0;
      let cz = 0;
      meshes.forEach((m) => {
        if (!m.getChildren().length) {
          l++;
          let ce = this.getElemCenter(null, m);
          let _r = this.getElemRadius(null, m);
          r = Math.max(r, _r);
          cx += ce.x;
          cy += ce.y;
          cz += ce.z;

        }
      })
      cx = cx / l
      cy = cy / l
      cz = cz / l
      c = { x: cx, y: cy, z: cz }
    } */
    return [c, r];
  }
  dradius = 2.63 * 10;
  moveCameraTo(el, view = null) {
    let dfx = this.datauxview.getDatascape();
    let camera = dfx.getCamera();
    let _view = view;
    if (!view) {
      let dr = this.getElemRadius(el);
      let target = this.getElemCenter(el);
      let ds = dr / Math.tan(camera.fov / 2);
      ds = Math.max(3, ds);
      _view = { distance: ds, target }
    }
    dfx.moveCamera(_view);
    setTimeout(() => {
      if (this.dragMode)
        this.reapplyDrag()
    }, 1000)
  }
  getDatascape() {
    return this.datauxview.getDatascape();
  }
  showHideElem(id, state) {
    let dfx = this.getDatascape();
    let elem = this.datauxview.getElementId(id);
    let info = this.getCtrlData(id);
    let profile = info ? info.profile || 'regular' : 'regular';
    if (!info.isSub) {
      return
    }
    if (this.viewObjectMode === 'texture') {
      profile = 'regular'
    }
    if (!state) {
      profile = 'invisible';
    } else {
      if (info.opacity === 'transparent') {
        profile = "transparent"
      }
    }
    info.visible = state;
    dfx.modify(elem, { profile });
    if (info.children.length && profile !== 'invisible') {
      // this.applyProfileToChildren(info);
    }
    /* if (info && info.id.includes("_arm")) {
      this.linkboatProfile(dfx, info.id, profile);
    } */
  }
  solidTransElem(id, solid) {
    let dfx = this.getDatascape();
    let elem = this.datauxview.getElementId(id);
    let info = this.getCtrlData(id);
    let profile = info ? info.profile || 'regular' : 'regular';
    info.opacity = 'solid';
    info.checked = !false;
    if (this.viewObjectMode === 'texture') {
      profile = 'regular'
    }
    if (!solid) {
      if (profile !== 'regular') {
        profile = "transparent"
      } else {
        profile = 'transparent';
      }
      if (!this.transMode) {
        profile = 'invisible';
      }
      info.opacity = 'transparent'
      info.checked = false;
    }
    dfx.modify(elem, { profile });
    if (info.children.length && profile !== 'invisible') {
      // this.applyProfileToChildren(info);
    }
    if (info && info.sensors) {
      info.sensors.forEach((sensor) => {
        let _profile = profile === 'invisible' ? profile : 'regular';
        let elem = this.datauxview.getElementId(sensor);
        let isSensorT = this.sensors.includes(sensor) && sensor.includes('target');
        let isCameraT = this.cameras.includes(sensor) && sensor.includes('target');
        if (isSensorT && this.sensorTargetOff) {
          _profile = 'invisible'
        }
        if (isCameraT && this.cameraTargetOff) {
          _profile = 'invisible'
        }
        if (elem) {
          dfx.modify(elem, { profile: _profile });
        }
      })
    }
  }
  /**
  * method for get center position of child mesh
  */
  getAverageCenter(m) {
    let meshes = m.getChildMeshes();
    let l = meshes.length;
    let c = [0, 0, 0]
    meshes.forEach((mesh) => {
      let pt = mesh.getBoundingInfo().boundingSphere.centerWorld
      c[0] += pt.x; c[1] += pt.y; c[2] += pt.z;
    });
    return { x: c[0] / l, y: c[1] / l, z: c[2] / l }
  }
  focusMode = false;
  focusElem(id, state) {
    let camera = this.dfx.getCamera();
    let s = state ? 'hide' : 'solid';
    this.resetElemState(s, id);
    let elem = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(elem);
    this.animEnv();
    if (!this.lastCamState) {
      this.lastCamState = this.getCamState();
    }
    let p = this.compDefPos[id];
    let _view = null;
    if (p && p.bound) {
      let dr = p.bound[1];
      let target = p.bound[0];
      let ds = dr / Math.tan(camera.fov / 2);
      ds = Math.max(3, ds);
      _view = { distance: ds, target: this.getAverageCenter(mesh) }
    }
    if (_view) {
      this.moveCameraTo(null, _view);
    } else {
      this.moveCameraTo(elem);
    }
  }
  focusChildElem(id) {
    let camera = this.dfx.getCamera();
    let elem = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(elem);
    if (!this.lastCamState) {
      this.lastCamState = this.getCamState();
    }
    let p = this.compDefPos[id];
    let _view = null;
    if (p && p.bound) {
      let dr = p.bound[1];
      let target = p.bound[0];
      let ds = dr / Math.tan(camera.fov / 2);
      ds = Math.max(3, ds);
      _view = { distance: ds, target: this.getAverageCenter(mesh) }
    }
    if (_view) {
      this.moveCameraTo(null, _view);
    } else {
      this.moveCameraTo(elem);
    }
  }
  resetSolidState() {
    let dfx = this.getDatascape();
    this.shipElems.forEach((c) => {
      if (!this.isSubSys(c)) {
        return
      }
      let elem = this.datauxview.getElementId(c);
      dfx.modify(elem, { profile: "regular" });
    })
    /* setTimeout(() => {
      this.onChangeCameraPosition('home')
    }, 0); */
  }
  isSubSys(c) {    
    let info = this.getCtrlData(c);
    if(info)
    return info.isSub;
  }
  getCtrlData(val, prop = 'id', action = 'eq') {
    let data = null;
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((c) => {
        if (action === 'eq') {
          if (c[prop] == val) {
            data = c;
          }
        }
        if (action === 'contains') {
          if (c[prop].includes(val)) {
            data = c;
          }
        }
      })
    }
    return data;
  }
  getCamState() {
    let dfx = this.getDatascape();
    let cam = dfx.getCamera();
    let distance = cam.distance.value;
    let target = { x: cam.targetX.value, y: cam.targetY.value, z: cam.targetZ.value };
    let yaw = cam.yaw_deg.value;
    let pitch = cam.pitch_deg.value;
    let view = { distance, target, yaw, pitch };
    return view;
  }

  getChildElems(key) {
    let shipElems = [];
    if (!this.objDrillDownDataPath) return shipElems;
    let shipCompCtls = this.objDrillDownDataPath[key];
    let comp = shipCompCtls.find(el => el.id === key);
    if (comp && comp.children.length) {
      shipElems = comp.children.map(el => el.id);
    }
    return shipElems;
  }

  lastCamState = null;
  componentLevel = [];
  componentDef = {};
  resetElemState(state = 'solid', exp = null) {
    let shipElems = this.shipElems;
    let dfx = this.getDatascape();
    if (state == 'solid') {
      this.componentLevel.pop();
      shipElems = this.shipElems;
      if (!this.componentLevel.length) {
        this.disableTrans = false;
        this.focusMode = false;
      } else {
        let key = this.componentLevel[this.componentLevel.length - 1];
        this.focus_title = this.componentDef[key]['name'];
        this.focus_col = this.componentDef[key]['color'];
        this.focusChildElem(key);
      }
    } else {
      this.focusMode = true;
      this.disableTrans = true;
      this.componentLevel.push(exp);
      if (this.componentLevel.length >= 2) {
        let len = this.componentLevel.length;
        let key = this.componentLevel[len - 2];
        shipElems = this.getChildElems(key);
      }
    }
    this.shipElems.forEach((c) => {
      if (!this.isSubSys(c)) {
        return
      }
      let elem = this.datauxview.getElementId(c);
      let info = this.getCtrlData(c);
      let profile = info ? info.profile || 'regular' : 'regular';
      if (this.viewObjectMode === 'texture') {
        profile = 'regular'
      }
      if (state != 'solid') {
        profile = 'invisible'
      } else {
        if (info) {
          if (info.opacity === 'transparent' && info.checked === false) {
            if (profile !== 'regular') {
              profile = "transparent"
            } else {
              profile = 'transparent';
            }
            if (!this.transMode) {
              profile = 'invisible';
            }
          } else {
            info.opacity = 'solid'
          }
        }
      }
      dfx.modify(elem, { profile: "regular" });
      dfx.modify(elem, { profile });
      if (info.children.length && profile !== 'invisible') {
        // this.applyProfileToChildren(info);
      }
      //this.applyLightConeProfile()
      let f = this.getFocusElem();
      if (f) {
        let i = this.getCtrlData(f);
        i.focus = false;
      }
      if (info && info.sensors) {
        info.sensors.forEach((sensor) => {
          let _profile = profile === 'invisible' ? profile : 'regular';
          let elem = this.datauxview.getElementId(sensor);
          let isSensorT = this.sensors.includes(sensor) && sensor.includes('target');
          let isCameraT = this.cameras.includes(sensor) && sensor.includes('target');
          if (isSensorT && this.sensorTargetOff) {
            _profile = 'invisible'
          }
          if (isCameraT && this.cameraTargetOff) {
            _profile = 'invisible'
          }
          if (elem) {
            dfx.modify(elem, { profile: _profile });
          }

        })
      }
    })
    if (exp) {
      let elem = this.datauxview.getElementId(exp);
      let info = this.getCtrlData(exp);
      let profile = info ? info.profile || 'regular' : 'regular';
      this.focus_title = "";
      this.focus_col = "#fff";
      if (this.viewObjectMode === 'texture') {
        profile = 'regular'
      }
      if (info) {
        this.focus_title = info.name;
        this.focus_col = info.color;
        this.componentDef[this.focus_title] = { name: this.focus_title, color: this.focus_col };
        info.focus = true;
        /* if (profile !== 'regular') {
          profile = info.profile + '_transparent'
        } else {
          profile = 'transparent';
        }
        info.opacity = 'transparent' */
      }
      dfx.modify(elem, { profile });
      if (info.children.length && profile !== 'invisible') {
        // this.applyProfileToChildren(info);
      }
      if (info && info.sensors) {
        info.sensors.forEach((sensor) => {
          let profile = 'regular';
          let elem = this.datauxview.getElementId(sensor);

          if (elem) {
            dfx.modify(elem, { profile });
          }
        })
      }
    } else {
      if (this.lastCamState) {
        this.moveCameraTo(null, this.lastCamState);
        this.lastCamState = null;
      }
    }
  }
  changeProfileCol(id, col) {
    let dfx = this.getDatascape();
    let elem = this.datauxview.getElementId(id);
    let info = this.getCtrlData(id);
    let profile = this.addNewProfileColor(col);
    if (info) {
      info.profile = profile;
      if (info.opacity === 'transparent') {
        profile = profile + "_transparent"
      }
    }
    dfx.modify(elem, { profile });
  }

  hideTransparentElem() {
    this.transMode = false;
    let dfx = this.getDatascape();
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((info) => {
        if (info.opacity === 'transparent' || !info.selected) {
          if (this.multipleTagStatus) {
            _console.log("multipleTagStatus", info)
            var elem = this.datauxview.getElementId(info.id)
            this.removeObserver(elem);
            let pop = document.getElementById('tooltip_' + info.id);
            pop.style.display = "none";
            //this.addObserver(elem);
            //this.selectedelem = elem;
          } else {
            if (this.selectedelem) {
              this.removeObserver(elem);
              let pop = document.getElementById('tooltip_' + info.id);
              pop.style.display = "none";
            }
          }

          this.showHideElem(info.id, false);
          info.visible = false;

          if (info && info.sensors) {
            info.sensors.forEach((sensor) => {
              let profile = 'invisible';
              let elem = this.datauxview.getElementId(sensor);
              /* let isSensor=this.sensors.includes(sensor);
              let isCamera = this.cameras.includes(sensor);
              if(isSensor&&this.sensorTargetOff){
                profile='invisible'
              }
              if(isCamera&&this.cameraTargetOff){
                profile='invisible'
              } */
              if (elem) {
                dfx.modify(elem, { profile });
              }
            })
          }
        }
      })
    }
  }
  showTransparentElem() {
    this.transMode = true;
    let dfx = this.getDatascape();
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((info) => {

        if (info.opacity === 'transparent' || !info.selected) {
          if (this.multipleTagStatus) {
            _console.log("multipleTagStatus", info)
            var elem = this.datauxview.getElementId(info.id)
            this.addObserver(elem);
          } else {
            if (this.selectedelem) {
              this.addObserver(elem);
            }
          }
          info.opacity = 'transparent';
          this.showHideElem(info.id, true);
          info.visible = true;

          if (info && info.sensors) {
            info.sensors.forEach((sensor) => {
              let profile = 'regular';
              let elem = this.datauxview.getElementId(sensor);
              let isSensorT = this.sensors.includes(sensor) && sensor.includes('target');
              let isCameraT = this.cameras.includes(sensor) && sensor.includes('target');
              if (isSensorT && this.sensorTargetOff) {
                profile = 'invisible'
              }
              if (isCameraT && this.cameraTargetOff) {
                profile = 'invisible'
              }
              if (elem) {
                dfx.modify(elem, { profile });
              }
            })
          }
        }
      })
    }
  }
  showHideTransElem(state) {
    if (state) {
      this.hideTransparentElem()
    } else {
      this.showTransparentElem();
    }
  }
  closeSubSystemView() {
    // this.processToAnimate(this.tagElement.id,false)
    if (!this.componentLevel.length) {
      this.focusMode = false;
    }
    this.clearChildCompDrag();
    let f = this.getFocusElem()
    this.onControlChange({ event: 'locate', name: f, state: false });
    this.broadcastInfo({ src: 'staterapp', event: 'loadShipComps', data: "reset" });
    this.broadcastInfo({ src: 'main', event: 'doreset', data: '' });
    
    this.profileForAnim(!this.idgAnimStatus);
  }
  controlChangeObj
  onControlChange(data) {
    let key = data.name;
    let f = "";
    if (this.controlChangeObj) {
      f = this.controlChangeObj;
    }
    this.controlChangeObj = data.name;
    let state = data.state;
    let event = data.event;
    if (event == 'operate') {
      this.setOperationMode()
      return
    }
    if (event == 'inspect') {
      this.setInspectMode()
      return
    }
    if (event === 'showhide') {
      this.showHideElem(key, state);
      this.showHideCompTargets(!this.multipleTagStatus);
      this.reapplyDrag();
    } else if (event === 'hilight_color') {
      this.changeProfileCol(key, state);
    } else if (event === 'comp_anim') {
      this.triggerCompAnim(key);
    } else if (event === 'demo_anim') {
      this.triggerDemoAnim(data);
    } else if (event === 'showhidecomp') {
      if (state) {
        let solidtrans = data.solidtrans;
        if (!solidtrans) {
          this.solidTransElem(key, solidtrans);
          this.showHideCompTargets(!this.multipleTagStatus);
          this.sensorHideShow(!this.sensorTargetOff);
          if (this.multipleTagStatus) {
            this.onShowAllTag({ state: true }, false);
          }
          this.reapplyDrag();
        } else {
          this.ctrlServ.showElement(key);
        }
      } else {
        this.ctrlServ.hideElement(key);
      }
    } else if (event === 'locate') {
      let compKey = data.key;
      let compId = data.id
      if (!state) {
        this.tagStatus = false;
        this.pickElement = false;
        // this.shipCompFocus(key);
        this.closeBack(this.shipCompsCntls['Components'][0], 'Components');

        this.resetElemState();
        this.stopEnvAnim(true);

        if (this.multipleTagStatus) {
          this.onShowAllTag({ state: true }, false);
        }
        this.showHideCompTargets(!this.multipleTagStatus);
        if (!this.globalPause) {
          this.compAnimStatus = 'playing';
          setTimeout(() => {
            this.animatorService.pauseAllAnim(false, true);
            this.animatorService.triggerPausedAnim(key);

            this.animatorService.showHideProps(true, key);
            this.reapplyDrag();
          }, 500)
        } else {
          //this.animatorService.triggerPausedAnim(key);
          this.animatorService.showHideProps(true, key);
        }

      } else {
        this.tagStatus = true;
        if (this.multipleTagStatus) {
          this.onShowAllTag({ state: false }, false);
          this.multipleTagStatus = true;
          this.animatorService.setTagStatus('multipleTagStatus', this.multipleTagStatus)
        }
        this.animatorService.showHideProps(!true);

        if (!this.globalPause) {
          this.animatorService.pauseAllAnim(true, true);
          this.compAnimStatus = 'paused';
        }

        this.animatorService.stopAnim(key, true, true);
        let el = this.datauxview.getElementId(key);
        // this.showTag(el);

        // this.onShowAllTag({state:false});
        this.showHideCompTargets(false);
        //this.animatorService.stopAllAnim(false);

        setTimeout(() => {
          this.focusElem(key, state);
          let passValue = { 'key': compKey, 'id': compId };
          this.onLocCtl(passValue, key);
          this.clearChildCompDrag();
          this.enableChildCompDrag(key);
        }, 100)
      }
      this.cameraHideShow(!this.cameraTargetOff);
      this.sensorHideShow(!this.sensorTargetOff);
    } else if (event === 'solidtrans') {
      this.solidTransElem(key, state);
      this.showHideCompTargets(!this.multipleTagStatus);
      this.sensorHideShow(!this.sensorTargetOff);
      if (this.multipleTagStatus) {
        this.onShowAllTag({ state: true }, false);
      }
      this.reapplyDrag();
    } else if (event === 'showhidetrans') {
      this.showHideTransElem(state);
      this.showHideCompTargets(!this.multipleTagStatus);
      this.sensorHideShow(!this.sensorTargetOff);
      this.reapplyDrag();
    } else if (event === 'inspectelem') {
      this.viewElement(key, state);
    } else if (event === 'showassembleparts') {
      if (state) {
        this.ctrlServ.modify(key);
        this.ctrlServ.showElement(key);
      } else {
        this.ctrlServ.hideElement(key);
      }
    }
  }
  setPropToAll(prop, value) {
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((c) => {
        c[prop] = value;
      })
    }
  }

  /**
   * dynamic color Profile
   * TO DO - create it as service and add it to datauxview
   */
  color_map = {};
  getHexToRGB(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [parseInt(result[1], 16) / 255, parseInt(result[2], 16) / 255, parseInt(result[3], 16) / 255] : [0, 0, 0];
  }
  initCanvas() {
    var canvas = document;
    canvas.addEventListener("pointerdown", (event) => {
      this.mousestate = 'down';

      // if (!this.dfx) return;
      // const hit = this.dfx.getHitPosition();
      // if (!hit.hit) return;
      // // console.log("-----", hit.pickedPoint, hit.pickedMesh.id);
      // const hpt = hit.pickedPoint;
      // console.log("Picked Point main : ", hit.pickedPoint);
      // console.log("Picked Point: ", hpt.x, hpt.z);
    })
    canvas.addEventListener("pointerup", (event) => {
      this.mousestate = 'up';
    })
    canvas.addEventListener("pointermove", (event) => {
      this.mousestate = 'up';
      this.mousepos = [event.clientX, event.clientY]
    })
  }
  texCAN
  createContext(width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }
  getTexture(w = 8, h = 8, col = "#ffffff") {
    if (!this.texCAN) {
      this.texCAN = this.createContext(w, h)
    }
    let ctx = this.texCAN.getContext("2d");
    ctx.clearRect(0, 0, w, h);
    ctx.beginPath();
    ctx.rect(0, 0, w, h);
    ctx.fillStyle = col;
    ctx.fill();
    let png = this.texCAN.toDataURL();
    return png;
  }
  addNewProfileToModels(prf, model = null) {
    let dfx = this.getDatascape();
    let prfs = { profiles: {} }
    let _p = {
      material: "",
      visible: true,
      selectable: true,
      transition: 0
    };
    let p = this.clone(_p);
    p.material = prf;
    prfs.profiles[prf] = p;
    p = this.clone(_p);
    p.material = prf + "_transparent";
    prfs.profiles[prf + "_transparent"] = p;
    if (model) {
      dfx.addProfiles(model, prfs.profiles);
    } else {
      this.shipComps.forEach((c) => {
        let model = this.datauxview.getElementId(c);
        if (model) {
          dfx.addProfiles(model, prfs.profiles);
        }
      })

      this.sensors.forEach((c) => {
        let model = this.datauxview.getElementId(c);
        if (model) {
          dfx.addProfiles(model, prfs.profiles);
        }
      })
      if (this.targetmodel) {
        dfx.addProfiles(this.targetmodel, prfs.profiles);
      }
    }
  }
  addNewProfileColor(col, addTex = true, prefix = "", model = null, trans = 0.3, bfc = true) {
    if (!col) {
      return;
    }
    let pcol = this.color_map[col];
    if (!pcol) {
      let dfx = this.getDatascape();
      let obj = { "id": "dfx_col1", "diffuse": [1, 1, 1], "specular": [0, 0, 0], "specularPower": 25, "ambient": [1, 1, 1], "backFaceCulling": bfc }
      let obj_transp = { "id": "dfx_col2_transparent", "diffuse": [1, 1, 1], "alpha": trans, "specular": [0, 0, 0], "specularPower": 25, "ambient": [1, 1, 1], "backFaceCulling": bfc }
      obj.id = prefix + "dfx_" + col;
      obj.diffuse = this.getHexToRGB(col);
      obj.ambient = [obj.diffuse[0] / 4, obj.diffuse[1] / 4, obj.diffuse[2] / 4]
      if (addTex) {
        obj['diffuseTexture'] = { "name": this.getTexture(8, 8, col) }
      } else {

      }
      //obj.ambient = obj.diffuse;
      let mat = [obj];
      dfx.addNewMaterials(mat);
      obj_transp.id = prefix + "dfx_" + col + "_transparent";
      obj_transp.diffuse = obj.diffuse;
      obj_transp.ambient = obj.ambient
      if (addTex) {
        obj_transp['diffuseTexture'] = obj['diffuseTexture']
      } else {

      }
      //obj_transp.ambient = obj.diffuse;
      obj_transp.alpha = trans;
      let mat2 = [obj_transp];
      dfx.addNewMaterials(mat2);

      this.addNewProfileToModels(prefix + "dfx_" + col, model);
      this.color_map[col] = prefix + "dfx_" + col
    } else {
      if (model) {
        this.addNewProfileToModels(this.color_map[col], model);
      }
    }
    return this.color_map[col];
  }
  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
  triggerCompAnim(key) {
    this.animatorService.onClick(null, key);
  }
  rotateComp(id, obj) {
    let mesh = this.dbobj[id][1];
    let r0 = this.compDefPos[id].rot[obj['axis']];
    let r1 = obj['value'];

    let rad = this.deg_toRad(r1);
    let val = r0 + rad;
    mesh.rotation[obj['axis']] = val;
  }
  deg_toRad(deg) {
    return deg * Math.PI / 180;
  }
  rad_toDeg(rad) {
    return rad * 180 / Math.PI;
  }
  globalPause = false;
  triggerDemoAnim(obj) {
    let key = obj.name;
    let id = key;
    let state = obj.state;
    /* if(key==="Box060"){
      if(state=='rotate'){
        this.rotateComp(key,{axis:'z',value:obj.data.val})
      }
    } */

    if (state == 'rotate') {
      this.rotateComp(key, { axis: obj.data.axis || 'y', value: obj.data.val * obj.data.dir })
    }
    if (state == 'rpm') {
      this["rpm_" + obj.data.id] = obj.data.val;
    }


    if (key === "stop") {
      this.animatorService.stopAllAnim();
    }
    if (key === "pause") {
      this.globalPause = state;
      this.startAnimation();
      this.animatorService.pauseAllAnim(state);
    }

  }
  targetmodel
  comp_target_arr = {};
  addTargetModel() {
    let dfx = this.datauxview.getDatascape();
    let opt = {
      shape: 'cameratarget',
      id: 'm_cameratarget',
      size: 1,
      profiles: {
        regular: {
          material: 'see_me_white',
          transition: 0
        },
        target: {
          material: 'target',
          transition: 0
        },
        stop: {
          material: 'stop',
          transition: 0
        }
      }
    }

    this.targetmodel = dfx.model(opt)
  }
  heli_targetmodel
  addHeliTargetModel() {
    let dfx = this.datauxview.getDatascape();
    let opt = {
      shape: 'cube',
      id: 'm_cube',
      size: 1,
      profiles: {
        regular: {
          material: 'see_me_white',
          transition: 0
        },
        target: {
          material: 'target_heli',
          transition: 0
        },
        stop: {
          material: 'stop_heli',
          transition: 0
        }
      }
    }

    this.heli_targetmodel = dfx.model(opt)
  }
  changeTargetProfile(targ, boo = false) {
    let dfx = this.datauxview.getDatascape();
    let profile = boo ? 'target' : 'stop';
    dfx.modify(targ, { profile })
  }
  createCompTarget(key, elem) {
    let dfx = this.datauxview.getDatascape();
    let info = this.getCtrlData(key);
    let profile = info.profile;
    let id = 'comp_target_' + key + "";
    let center = this.getElemCenter(elem);
    let dr = this.getElementMaxY(elem) + 1;//this.getElemRadius(elem) * 0.75
    let pos: any = { x: center.x, y: dr, z: center.z };
    if (!this.targetmodel) {
      this.addTargetModel();
    }
    let orientation = { x: 0, y: 0, z: 0 }
    if (key === 'CH148') {
      pos = { x: -0.5, y: 5.5, z: 60.8 }
      orientation = { x: 90, y: 180, z: 0 }
      if (!this.heli_targetmodel) {
        this.addHeliTargetModel();
        this.addNewProfileColor(info.color, true, "", this.heli_targetmodel)
      }
    }
    this.comp_target_arr[key] = []
    let p
    this.comp_target_arr[key][0] = p = dfx.add({
      id,
      model: key === 'CH148' ? this.heli_targetmodel : this.targetmodel,

      geometry: { position: { x: pos.x, y: pos.y, z: pos.z }, orientation, size: 0.5 }
    });
    let child1 = this.comp_target_arr[key][1] = dfx.add({
      id: id + "_c_1",
      model: key === 'CH148' ? this.heli_targetmodel : this.targetmodel,
      profile: 'target',
      geometry: { position: { x: 0, y: 0, z: -0.1 }, size: 1 }
    });
    if (key === "CH148") {
      dfx.setElementScale(p, [4.8, 4.8 / 3, 0.1])
    }
    dfx.modify(p, { profile })
    //dfx.modify(child1, { profile: "regular" })

    dfx.setAsParent(p, [child1]);
    if (key !== "CH148") {
      dfx.getElementMesh(p).billboardMode = 7;
    }


  }
  isCompVisible(c) {
    let comp = this.datauxview.getElementId(c);
    let dfx = this.getDatascape();
    let props = dfx.props(comp);
    let vis = props.profile.visible;
    return vis;
  }
  showHideCompTargets(_boo, key = 'all') {
    let boo = _boo;
    if (_boo && this.compTargetOff) {
      boo = false;
    }
    this.compTargets.forEach((c) => {
      if (key === 'all' || c === key) {
        let arr = this.comp_target_arr[c];
        if (arr && arr.length) {
          let el = arr[0];
          let info = this.getCtrlData(c);
          let elm = this.getDatascape().getElementMesh(el);
          let cboo = this.isCompVisible(c) && info.selected;
          elm.isVisible = boo ? cboo : boo;
          elm.getChildMeshes().forEach((m) => {
            m.isVisible = elm.isVisible;
          })
          if (elm.isVisible) {
            this.changeTargetProfile(arr[1], !info.playing)
          }

        }
      }
    })
  }

  allMeshes = [];
  imat = {};
  beamId;
  resetMeshAmbient() {
    this.allMeshes.forEach((obj) => {
      let id = obj[0];
      let m = obj[1];
      let process = m.isVisible;
      if (!process) {
        return
      }
      if (this.imat[id]) {
        m.material = this.imat[id]
      }

    })
  }

  cameraCardClick(e) {    
    // e.preventdefault();
    return false;
  }
  showAllCompCtrl() {
    this.doreset = true;
    this.resetCompCtls();
    this.applyCompProfiles();
    this.setShipCompsCntls();
    this.doreset = false;
    this.disableTrans = false;
  }
  applyParentChild() {
    let dfx = this.datauxview.getDatascape();
    this.shipComps.forEach((key) => {
      let parent = this.dbobj[key]?this.dbobj[key][1]:null;
      if(parent==null) return;
      let info = this.getCtrlData(key)
      if (info.isSub && info.children.length) {
        let c = info.children;
        c.forEach((cinfo) => {
          let id = cinfo['id'];
          if (id !== key) {
            let _child = this.dbchildobj[id]?this.dbchildobj[id][1]:null;
            if(_child==null) return;
            _child.setParent(parent);

            if (cinfo.isSub && cinfo.children.length) {
              let cc = cinfo.children;
              cc.forEach((ccinfo) => {
                let id = ccinfo['id'];
                if (id !== key) {
                  let _cchild = this.dbchildobj[id][1];
                  _cchild.setParent(_child);
                }
              })
            }
          }
        })
      }
    })
  }
  getDifference(a, b) {
    return a > b ? a - b : b - a;
  }
  getDistance(p1, p2) {
    let dx = p1.x - p2.x;
    let dy = p1.y - p2.y;
    let dz = p1.z - p2.z;
    let distance = Math.sqrt(dx * dx + dy * dy + dz * dz);
    return distance;
  }

  dragedComponentName = "";
  removeDragElement = ['base_frame'];
  reapplyDrag() {
    if (!this.dragMode) {
      this.removeDrag("null", true);
      return;
    }
    if (this.disableTrans) {
      this.removeDrag("null", true);
      return;
    }
    let dfx = this.datauxview.getDatascape();
    let v = this.getCamPlane();
    this.shipComps.forEach((key) => {
      let child = this.dbobj[key][1];
      let info = this.getCtrlData(key)
      if (!child.isEnabled() || !info.isSub) {
        return;
      }
      if (!info.selected || info.opacity === 'transparent') {
        this.removeDrag(key);
        if (info.opacity === 'transparent') {
          child.isPickable = false;
        }
      } else {
        this.removeDrag(key);
        child.isPickable = !false;
        let b = dfx.getDragBehavior([v.x, v.y, v.z])
        b.useObjectOrientationForDragging = false;
        child.addBehavior(b);
        this.dbobj[key][0] = b;
        let dragStartPos = {};

        b.onDragStartObservable.add((event) => {
          if (this.testMode == 'quiz') {
            this.dragedComponentName = child.name.split("element-")[1];
            this.ctrlServ.dragedComponentName = this.dragedComponentName;
            let pos = child.position;
            dragStartPos = { x: pos['x'], y: pos['y'], z: pos['z'] }
          }
        })

        b.onDragEndObservable.add((event) => {
          let pos = child.position;
          if (this.testMode == 'quiz') {
            let _x = this.getDifference(dragStartPos['x'], pos.x);
            let _y = this.getDifference(dragStartPos['y'], pos.y);
            let _z = this.getDifference(dragStartPos['z'], pos.z);
            if (_x >= 0 || _y >= 0 || _z >= 0) {
              let x = (Math.sign(parseFloat(pos.x.toFixed(4))) === 1 || Math.sign(parseFloat(pos.x.toFixed(4))) === 0 ? - parseFloat(pos.x.toFixed(4)) : parseFloat(pos.x.toFixed(4)))
              let y = parseFloat(pos.y.toFixed(4));
              let z = parseFloat(pos.z.toFixed(4));
              let _pos = { x, y, z };
              this.ctrlServ.dragedComponentPos = JSON.parse(JSON.stringify(_pos));
              var divRect = document.getElementById('dropBox').getBoundingClientRect();
              let cx = this.mousepos[0];
              let cy = this.mousepos[1];
              if (cx >= divRect.left && cx <= divRect.right && cy >= divRect.top && cy <= divRect.bottom) {
                this.broadcastInfo({ src: 'main', event: 'validate-answer', data: '', sub: null });
              }
            }
          } else if (this.testMode == 'assemble-parts') {
            this.quizCorrectPopup = !true;
            let c = this.getMeshName(child.id);
            let dpos = this.children[c]['pos'];
            let cpos = { x: pos.x, y: pos.y, z: pos.z };
            let dist = this.getDistance(dpos, cpos);
            //console.log(c, 'distance :: ', dist);

            const idx = this.quizList.findIndex(el => el.question == c);
            if (dist <= this.ctrlServ.moe) {
              this.ctrlServ.modifyElement(c, dpos);
              this.removeDragElement.push(c);
              this.removeDrag(c);
              if (idx > -1) {
                this.quizCorrectPopup = true;
                this.quizList[idx]['answer'] = c;
                this.quizList[idx]['answerStatus'] = true;
                setTimeout(() => this.quizCorrectPopup = !true, 1000);
              }
            } else {
              if (idx > -1) {
                this.quizList[idx]['answer'] = c;
              }
            }

            const showResult = this.quizList.every(el => el.answerStatus === true);
            if (showResult) {
              this.removeDrag("null", true);
              this.broadcastInfo({ src: 'main', event: 'show-quiz-panel', data: "quiz", key: true });
            }
          }
        });

      }
    })
  }
  enableDragEngine() {
    var engine = this.getMesh('imodel');
    let dfx = this.datauxview.getDatascape();
    engine.getChildMeshes().forEach((m) => {
      let b = dfx.getDragBehavior([0, 0, 1])
      b.useObjectOrienationForDragging = false;
      b.updateDragPlane = false;
      m.addBehavior(b);
      var mid = this.getMeshID(m)
      this.dbobjEngineAnimation[mid][0] = b;
    })
  }
  removeDragEngine() {
    let keys = Object.keys(this.dbobjEngineAnimation);
    keys.forEach((key) => {
      if (this.dbobjEngineAnimation[key][0])
        this.dbobjEngineAnimation[key][1].removeBehavior(this.dbobjEngineAnimation[key][0]);
      this.dbobjEngineAnimation[key][0] = null;
    })
  }
  enableDrag() {
    let dfx = this.datauxview.getDatascape();
    this.shipComps.forEach((key) => {
      let child = this.dbobj[key][1];
      let info = this.getCtrlData(key)
      if (!child.isEnabled() || !info.isSub) {
        return;
      }

      let b = dfx.getDragBehavior([0, 0, 1])
      b.useObjectOrienationForDragging = false;
      b.updateDragPlane = false;
      child.addBehavior(b);
      this.dbobj[key][0] = b;
    })
  }
  removeDrag(m, except = false) {
    if (m && except) {
      let keys = Object.keys(this.dbobj);
      keys.forEach((key) => {
        if (key != m) {
          if (this.dbobj[key][0])
            this.dbobj[key][1].removeBehavior(this.dbobj[key][0]);
          this.dbobj[key][0] = null;
        }
      })
    } else if (m) {
      if (this.dbobj[m] && this.dbobj[m][0]) {
        this.dbobj[m][1].removeBehavior(this.dbobj[m][0]);
        this.dbobj[m][0] = null;
      }
    }
  }

  /* * * * 
   * drag for child component in focusmode start
   * * * */
  enableChildCompDrag(key, compKey = 'Components') {
    let dfx = this.datauxview.getDatascape();
    let parent_el = this.datauxview.getElementId(key);
    if (!parent_el) return;
    this.shipCompsCntls[compKey].forEach(c => {
      let cid = c['id'];
      if (cid === key) {
        let hmesh = this.dfx.getElementMesh(parent_el);
        if (!this.dbchildobj[cid]) {
          let b = dfx.getDragBehavior([0, 0, 1]);
          this.dbchildobj[cid] = [b, hmesh];
        }
      } else {
        let child = this.dbchildobj[cid][1];
        let info = this.getCtrlData(cid);
        if (!child.isEnabled() || !info.isSub) {
          return;
        }
        child.isPickable = !false;
        let b = dfx.getDragBehavior([0, 0, 1])
        b.useObjectOrienationForDragging = false;
        b.updateDragPlane = false;
        child.addBehavior(b);
        this.dbchildobj[cid][0] = b;
      }
    });
    this.broadcastInfo({ src: 'starterapp', event: 'drill-down', data: this.shipCompsCntls, key: "" });
  }
  clearChildCompDrag(compKey = 'Components') {
    this.resetChildCompDrag(compKey);
    this.removeChildCompDrag(null, true, compKey);
  }
  resetChildCompDrag(compKey = 'Components') {
    this.shipCompsCntls[compKey].forEach((c) => {
      let cid = c['id'];
      let obj = this.dbchildobj[cid];
      if (obj) {
        let p = this.children[cid].pos;
        let mesh = obj[1];
        mesh.position.x = p.x;
        mesh.position.y = p.y;
        mesh.position.z = p.z;
      }
    });
  }
  removeChildCompDrag(m, except = false, compKey = 'Components') {
    if (m && except) {
      this.shipCompsCntls[compKey].forEach((c) => {
        let cid = c['id'];
        if (this.dbchildobj[cid]) {
          this.dbchildobj[cid][1].removeBehavior(this.dbchildobj[cid][0]);
          this.dbchildobj[cid][0] = null;
        }
      });
    } else if (m) {
      if (this.dbchildobj[m] && this.dbchildobj[m][0]) {
        this.dbchildobj[m][1].removeBehavior(this.dbchildobj[m][0]);
        this.dbchildobj[m][0] = null;
      }
    }
  }
  /* * * *
  * drag for child component in focusmode end
  * * * */

  compLastState: any = {};
  saveState() {
    this.compLastState.cdata = JSON.stringify(this.shipCompsCntls);
    this.compLastState.camera = this.getCamState()
    this.shipComps.forEach((key) => {
      let parent = this.dbobj[key][1];
      let info = this.getCtrlData(key)
      if (info.isSub) {
        let pos = { x: parent.position.x, y: parent.position.y, z: parent.position.z }
        let rot = { x: parent.rotation.x, y: parent.rotation.y, z: parent.rotation.z }
        let scale = { x: parent.scaling.x, y: parent.scaling.y, z: parent.scaling.z }
        this.compLastState[key] = [pos, rot, scale];
      }
    })
  }
  loadState() {
    this.shipCompsCntls = JSON.parse(this.compLastState.cdata);
    this.shipComps.forEach((key) => {
      let parent = this.dbobj[key][1];
      let info = this.getCtrlData(key)
      if (info.isSub) {
        let pos = this.compLastState[key][0];
        let rot = this.compLastState[key][1];
        let scale = this.compLastState[key][2];
        parent.position.x = pos.x;
        parent.position.y = pos.y;
        parent.position.z = pos.z;
        //
        parent.rotation.x = rot.x;
        parent.rotation.y = rot.y;
        parent.rotation.z = rot.z;
        //
        parent.scaling.x = scale.x;
        parent.scaling.y = scale.y;
        parent.scaling.z = scale.z;
      }
    });
    let camState = this.compLastState.camera;
    if (camState) {
      this.moveCameraTo(null, camState);
      this.compLastState.camera = null;
    }
  }
  resetWrongAnswerdComp(key) {
    let info = this.getCtrlData(key);
    let isSub = info.isSub;
    if (isSub) {
      this.resetChild(key);
    }
  }
  updateDragedCompPosition(m, pos) {
    let obj = this.dbobj[m]
    if (obj) {
      let p = pos;
      let mesh = obj[1];
      mesh.position.x = p.x;
      mesh.position.y = p.y;
      mesh.position.z = p.z;
    }
  }
  resetChildren() {
    let keys = Object.keys(this.dbobj);
    keys.forEach((key) => {
      let info = this.getCtrlData(key);
      let isSub = info.isSub;
      if (isSub) {
        this.resetChild(key);
      }
    })
  }
  resetChild(m) {
    let obj = this.dbobj[m]
    if (obj) {
      let p = this.children[m].pos;
      let mesh = obj[1];
      mesh.position.x = p.x;
      mesh.position.y = p.y;
      mesh.position.z = p.z;
    }
  }

  resetChildEngine(m) {
    let obj = m
    if (obj) {
      var m = this.getMeshID(m)
      let p = this.engineAnimationPostion[m].position;
      let mesh = obj
      mesh.position.x = p.x;
      mesh.position.y = p.y;
      mesh.position.z = p.z;
    }
  }
  /**
   * Drag Update
   */
  @HostListener('document:pointerup', ['$event'])
  handlePointerUpEvent(event: MouseEvent) {
    let t: any = event.target
    if (t.nodeName === 'CANVAS') {
      if (this.dragMode) {
        this.reapplyDrag();
        if (this.testMode === 'assemble-parts') {
          this.removeDragElement.forEach((c) => {
            this.removeDrag(c);
          })
        }
      }
    }
  }
  getCamPlane() {
    let dfx = this.datauxview.getDatascape();
    let cam = dfx.getCamera();
    let yaw = cam.yaw_deg.value;
    let pitch = cam.pitch_deg.value;
    let x = Math.sin(yaw * Math.PI / 180);
    let z = Math.cos(yaw * Math.PI / 180);
    let y = 0;
    if (pitch > 70) {
      x = z = 0;
      y = 1;
    }
    //let vec3 = dfx.getVector()
    let v = this.getVector(x, y, z);
    return v;
  }
  setDragPlane(event, b) {
    //
    let v = this.getCamPlane();
    b._options = { dragPlaneNormal: v }
  }
  resetDragPlane(event, b) {
    //
    let v = this.getVector(1, 0, 0);
    b._options = { dragPlaneNormal: v }
  }
  getVector(x, y, z) {
    let dfx = this.datauxview.getDatascape();
    let vec3 = dfx.getVector()
    let v = new vec3(x, y, z)
    return v
  }
  /* processModel() {
    let cam = this.dfx.getCamera();
    let scene = cam.getScene();
    scene.materials.forEach((m) => {
      if (m.metallic) {
        m.metallic = 0.5;
        m.roughness = 0.5;
      }
    })
  } */
  processModel() {
    let app = this;

    this.scene.activeCamera._getViewMatrix = function () {
      var bp = 0;
      this.CalcPosition();
      this._computeViewMatrix(this.position, this.GetTargetPos(), this.upVector);
      return this._viewMatrix;
    };
    let hdrTexture = this.scene.environmentTexture;
    //hdrTexture.rotationY=-Math.PI
    app.scene.environmentBRDFTexture = null;
    for (let i = 0; i < app.scene.materials.length; i++) {
      let mtl = app.scene.materials[i];
      let mtl_clname = mtl.getClassName();
      if (mtl_clname === "PBRMaterial") {
        let pbr = mtl;
        pbr.albedoColor.r *= 1.28;
        pbr.albedoColor.g *= 1.28;
        pbr.albedoColor.b *= 1.28;

        if (pbr.metallic == 0) {
          pbr.roughness = 1; //model s/b fixed <---------------------------------------

        }
        //this is always 0 in Blender, but becomes 1 here
        pbr.specularIntensity = 0;
       // console.log("  specIntensity:" + pbr.specularIntensity + " forced to zero");
        //the master light switch
       // console.log("  envIntensity:" + pbr.environmentIntensity);
        //Babylon's clearcoat seems overly bright and washed out
        //so we turn it down half way
        if (pbr.clearCoat.isEnabled) {
          let orig = pbr.clearCoat.intensity;
          pbr.clearCoat.intensity *= 0.5;
        //  console.log("  cc_Intensity:" + orig + " changed to " + pbr.clearCoat.intensity);
        //  console.log("  cc_roughness:" + pbr.clearCoat.roughness);
        }
        else {
          //console.log("  cc disabled");
        }
        //pbr.environmentBRDFTexture = hdrTexture;
        /* let metal=pbr;
        let hdrTexture=this.scene.environmentTexture
        metal.reflectionTexture = hdrTexture;
        metal.microSurface = 0.96;
        metal.reflectivityColor = new BABYLON.Color3(0.85, 0.85, 0.85); */


        //console.log("  pbr ", pbr);
        ////turn off all lighting to allow diffuse (albedo) colour camparision
        ////between babylon and blender
        //pbr.unlit = true;
      }
      else {
        //console.log("Mtl:" + mtl.name + " NOT PBR.");
      }
    }
  }
  getMeshName(n) {
    if (!n) {
      return 'unknown'
    }
    let arr = n.split(".");
    if (arr.length === 1) {
      return arr[0]
    }
    if (arr.length === 0) {
      return "unknown"
    }
    if (!isNaN(arr[arr.length - 1])) {
      return arr[arr.length - 2] + "." + arr[arr.length - 1]
    }
    return arr[arr.length - 1];
  }
  getMesh(id) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    return mesh;
  }
  getChildMesh(id, cid) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    let meshes = mesh.getChildMeshes();
    let idx = meshes.findIndex(e => e.name.includes("." + cid));
    if (idx > -1) {
      return meshes[idx];
    }
    return null;
  }
  getChildMeshEx(id, cid,_mesh=null) {
    let el = id?this.datauxview.getElementId(id):null;
    let mesh = id?this.dfx.getElementMesh(el):null;
    if(_mesh){
      mesh=_mesh;
    }
    if(!mesh){
      return null
    }
    let meshes = mesh.getChildMeshes();
    let idx = meshes.findIndex(e => this.getMeshName(e.name) === cid);
    if (idx > -1) {
      return meshes[idx];
    }
    return null;
  }
  getChildTransEx(id, cid,_mesh=null) {
    let el = id?this.datauxview.getElementId(id):null;
    let mesh = id?this.dfx.getElementMesh(el):null;
    if(_mesh){
      mesh=_mesh;
    }
    if(!mesh){
      return null
    }
    let meshes = mesh.getChildTransformNodes();
    let idx = meshes.findIndex(e => this.getMeshName(e.name) === cid);
    if (idx > -1) {
      return meshes[idx];
    }
    return null;
  }
  explosion: any;
  explosion_cm
  initExplodeMesh(id = 'imodel') {

    let meshes = [];
    if (!this.explosion) {
      this.shipComps.forEach((c) => {
        let comp = this.getMesh(c);
        meshes.push(comp);
        /* if(comp.getChildren().length){
          meshes.push(...comp.getChildMeshes());
        }else{
          meshes.push(comp);
        } */

      })
      let cm = "flywheel_exterior"
      let centerMesh = this.getMesh(cm);
      this.explosion_cm = centerMesh;
      this.explosion = new BABYLON.MeshExploder(meshes, centerMesh)
    }
  }
  explodeMesh(i = 1) {
    this.explosion.explode(i);
    let p = this.explosion_cm.getAbsolutePosition();
    let camera = this.dfx.getCamera();
    camera.targetX.value = p.x;
    camera.targetY.value = p.y;
    camera.targetZ.value = p.z;
  }
  resetMeshExplode() {
    this.showHideLand(!false);
    this.explosion.explode(0);
  }

  /* * *
  * control panel state
  * * */
  settingPanelState(e) {
    this.controlPanelState = e;
  }

  onLoadNetworkComponent() {
    this.broadcastInfo({ src: 'main', event: 'changeview', data: "network", key: '' });
  }
  /**
   * 
   * Toms material definitions
   */
  mtls: any = {};
  MakePaintMaterial(name, diff) {
    let paint = new BABYLON.PBRSpecularGlossinessMaterial(name, this.scene);
    paint.diffuseColor = diff.clone();
    paint.specularColor = new BABYLON.Color3(0, 0, 0);
    paint.glossiness = 0.000001;
    let paint1 = paint;
    let paint2 = paint1;
    paint2.environmentIntensity = 0.075; //0.2;//0.375;//
    paint.backFaceCulling = true;
    return paint;
  }
  replaceMats() {
    let factor = 1;
    this.mtls["black_paint"] = this.MakePaintMaterial("black_paint", new BABYLON.Color3(0 * factor, 0 * factor, 0 * factor));
    this.mtls["fuel_injection"] = this.MakePaintMaterial("fuel_injection", new BABYLON.Color3(0.08714 * factor, 0.08714 * factor, 0.08714 * factor));
    this.mtls["dark_grey"] = this.MakePaintMaterial("dark_grey", new BABYLON.Color3(0.04000 * factor, 0.04000 * factor, 0.04000 * factor));
    this.mtls["med_grey"] = this.MakePaintMaterial("med_grey", new BABYLON.Color3(0.10000 * factor, 0.10000 * factor, 0.10000 * factor));
    this.mtls["light_grey"] = this.MakePaintMaterial("light_grey", new BABYLON.Color3(0.37574 * factor, 0.37574 * factor, 0.37574 * factor));
    this.mtls["panel_gasket"] = this.MakePaintMaterial("panel_gasket", new BABYLON.Color3(0.40196 * factor, 0.10725 * factor, 0.03764 * factor));
    this.mtls["yellow_paint"] = this.MakePaintMaterial("yellow_paint", new BABYLON.Color3(0.70000 * factor, 0.50000 * factor, 0.03000 * factor));
    this.mtls["btn_white"] = this.MakePaintMaterial("btn_white", new BABYLON.Color3(0.80000 * factor, 0.80000 * factor, 0.80000 * factor));
    this.mtls["btn_red"] = this.MakePaintMaterial("btn_red", new BABYLON.Color3(1 * factor, 0.00283 * factor, 0 * factor));
    this.mtls["btn_green"] = this.MakePaintMaterial("btn_green", new BABYLON.Color3(0.00444 * factor, 0.75775 * factor, 0.16594 * factor));
    this.mtls["rad_face"] = this.MakePaintMaterial("rad_face", new BABYLON.Color3(0.60027 * factor, 0.60027 * factor, 0.60027 * factor));
    factor = .5;
    this.mtls["filters"] = this.MakePaintMaterial("filters", new BABYLON.Color3(0.83000 * factor, 0.81000 * factor, 0.67000 * factor));
    factor = .45;
    this.mtls["engine_cooling"] = this.MakePaintMaterial("engine_cooling", new BABYLON.Color3(0.40000 * factor, 0.60000 * factor, 0.77000 * factor));
    factor = .5;
    this.mtls["oily"] = this.MakePaintMaterial("oily", new BABYLON.Color3(0.48000 * factor, 0.58000 * factor, 0.35000 * factor));
    factor = .30;
    this.mtls["intercooler"] = this.MakePaintMaterial("intercooler", new BABYLON.Color3(0.750 * factor, 1.000 * factor, 0.750 * factor));
    this.mtls["turbocharger"] = this.MakePaintMaterial("turbocharger", new BABYLON.Color3(1.000 * factor, 0.800 * factor, 0.800 * factor));
    factor = .45;
    this.mtls["exhaust"] = this.MakePaintMaterial("exhaust", new BABYLON.Color3(0.850 * factor, 0.950 * factor, 0.950 * factor));
    factor = 0.65;
    this.mtls["air_intake"] = this.MakePaintMaterial("air_intake", new BABYLON.Color3(0.500 * factor, 0.650 * factor, 1.000 * factor));
    factor = 0.18;
    this.mtls["starter_circuit"] = this.MakePaintMaterial("starter_circuit", new BABYLON.Color3(0.270 * factor, 0.900 * factor, 0.260 * factor));
    this.mtls["__GLTFLoader._default"] = this.MakePaintMaterial("__GLTFLoader._default", new BABYLON.Color3(1, 1, 1));
    let mats = Object.keys(this.mtls);
    mats.forEach((m) => {
      let mat = this.scene.getMaterialByName(m);
      if (mat) {
        mat.albedoColor = this.mtls[m].diffuseColor;
      }
    })
  }
  /**
   * 
   * engine animation from blender
   */
  col_anim_1;
  col_anim_2;
  col_anim_3;
  col_anim_4;
  initColorAnim() {
    let fps = 1;
    let prop = "diffuseColor";
    this.col_anim_1 = new BABYLON.Animation("engine_anim01", "material." + prop, fps, BABYLON.Animation.ANIMATIONTYPE_COLOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
    let keys = [];
    keys.push({
      frame: 0,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    keys.push({
      frame: 3,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    keys.push({
      frame: 4,
      value: new BABYLON.Color3(1, 0, 0)
    });
    keys.push({
      frame: 5,
      value: new BABYLON.Color3(1, 0.4, 0)
    });
    keys.push({
      frame: 6,
      value: new BABYLON.Color3(0.0, 0.0, 0.0)
    });
    keys.push({
      frame: 9,
      value: new BABYLON.Color3(0, 0, 0)
    });
    keys.push({
      frame: 10,
      value: new BABYLON.Color3(1, 1, 1)
    });
    keys.push({
      frame: 12,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    this.col_anim_1.setKeys(keys.slice());
    this.col_anim_2 = new BABYLON.Animation("engine_anim02", "material." + prop, fps, BABYLON.Animation.ANIMATIONTYPE_COLOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
    keys = [];
    keys.push({
      frame: 0,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    keys.push({
      frame: 1,
      value: new BABYLON.Color3(1, 0, 0)
    });
    keys.push({
      frame: 2,
      value: new BABYLON.Color3(1, 0.4, 0)
    });
    keys.push({
      frame: 3,
      value: new BABYLON.Color3(0.0, 0.0, 0.0)
    });
    keys.push({
      frame: 6,
      value: new BABYLON.Color3(0, 0, 0)
    });
    keys.push({
      frame: 8,
      value: new BABYLON.Color3(1, 1, 1)
    });
    keys.push({
      frame: 10,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    keys.push({
      frame: 12,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    this.col_anim_2.setKeys(keys.slice());
    //
    prop = "ambientColor";
    this.col_anim_3 = new BABYLON.Animation("engine_anim01", "material." + prop, fps, BABYLON.Animation.ANIMATIONTYPE_COLOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
    keys = [];
    keys.push({
      frame: 0,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    keys.push({
      frame: 3,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    keys.push({
      frame: 4,
      value: new BABYLON.Color3(1, 0, 0)
    });
    keys.push({
      frame: 5,
      value: new BABYLON.Color3(1, 0.4, 0)
    });
    keys.push({
      frame: 6,
      value: new BABYLON.Color3(0.0, 0.0, 0.0)
    });
    keys.push({
      frame: 9,
      value: new BABYLON.Color3(0, 0, 0)
    });
    keys.push({
      frame: 10,
      value: new BABYLON.Color3(1, 1, 1)
    });
    keys.push({
      frame: 12,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    this.col_anim_3.setKeys(keys.slice());
    this.col_anim_4 = new BABYLON.Animation("engine_anim02", "material." + prop, fps, BABYLON.Animation.ANIMATIONTYPE_COLOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
    keys = [];
    keys.push({
      frame: 0,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    keys.push({
      frame: 1,
      value: new BABYLON.Color3(1, 0, 0)
    });
    keys.push({
      frame: 2,
      value: new BABYLON.Color3(1, 0.4, 0)
    });
    keys.push({
      frame: 3,
      value: new BABYLON.Color3(0.0, 0.0, 0.0)
    });
    keys.push({
      frame: 6,
      value: new BABYLON.Color3(0, 0, 0)
    });
    keys.push({
      frame: 8,
      value: new BABYLON.Color3(1, 1, 1)
    });
    keys.push({
      frame: 10,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    keys.push({
      frame: 12,
      value: new BABYLON.Color3(0.44, 0.7, 0.68)
    });
    this.col_anim_4.setKeys(keys.slice());
  }
  addColorAnim(ag, mesh, type) {
    let col_anim = type === 1 ? this.col_anim_1 : this.col_anim_2;
    ag.addTargetedAnimation(col_anim, mesh);
    let col_anim2 = type === 1 ? this.col_anim_3 : this.col_anim_4;
    ag.addTargetedAnimation(col_anim2, mesh);
  }
  debug_ag = []
  initEngineAnim() {
    let scene = this.scene;
    //scene.stopAllAnimations();
    let ag = scene.animationGroups;
    ag.forEach((g) => {
      let norm = false;
      g.targetedAnimations.forEach((a) => {
        let parent = a.target.parent
        if(!parent){
          return;
        }
        let _id='imodel';
        let _mesh=null
        let _p=this.getMeshName(a.target.name);
        parent=a.target;
        let itr=0
        while(!(this.dbobj[_p]||this.dbchildobj[_p])){

          parent=parent.parent;
          if(!parent){
            return;
          }
          _p=this.getMeshName(parent.name);;
        }
        //a.target.parent.parent.parent
        /* if(_p.includes("camshaft")||_p.includes("pistons+crank")||_p.includes("timimg_gears")){
          parent=a.target.parent.parent.parent;
        }
        if(_p.includes("empty")){
          parent=a.target.parent.parent.parent.parent.parent;
        }
        if(_p.includes("armature")){
          parent=a.target.parent.parent.parent.parent.parent.parent;
        }
        if(_p.includes("bone")){
          parent=a.target.parent.parent.parent.parent.parent.parent.parent;
        }
        if(_p.includes("valve_train_cyl")){
          parent=a.target.parent.parent.parent.parent
        } */
        let pn
        if(parent){
           pn=this.getMeshName(parent.name);
          let state =false;
          let dbObj;
          if(this.dbobj[pn]){
            state=true;
          }else{
            state = false;
          }
          if(state){
            dbObj =this.dbobj[pn][1];
            state = false;
          }
          if(this.dbchildobj[pn]){
            state=true;
          }else{
            state = false;
          }
          if(state){
            dbObj =this.dbchildobj[pn][1];
            state = false;
          }
          /* if(pn==='cylinder head assembly'){
            let n = a.target.name
            let _mesh = this.getChildTransEx(_id, pn);
            let _nt = this.getChildMeshEx(null, n,_mesh);
            
            if (a.target.getClassName() === 'TransformNode' && !_nt) {
              _nt = this.getChildTransEx(null, n,_mesh);
            }
            a.target = _nt; 
          } */
          if(!dbObj) return;
          let pm=null;//this.dbobj[pn][1]||this.dbchildobj[pn][1];
          if(this.dbobj[pn]&&this.dbobj[pn][1]){
            pm=this.dbobj[pn][1]
          }else
          if(this.dbchildobj[pn]&&this.dbchildobj[pn][1]){
            pm=this.dbchildobj[pn][1]
          }
          if(pm&&(a.target.name!=pn)){
            _id=null;
            _mesh=pm;
          }
          let n =(a.target.name==pn)?pm.name: a.target.name
        let nt = this.getChildMeshEx(_id, n,_mesh);
        if (a.target.getClassName() === 'TransformNode' && !nt) {
          nt = this.getChildTransEx(_id, n,_mesh);
        }
        a.target = nt; 
        }
              

      })
      if (norm) {
        this.debug_ag.push(g);
      }
      g.reset();
      //g.normalize(0, 13);
    })
    
  }
  engineTransToggle(boo) {
    /* let c1 = this.getChildMeshEx('iengine', 'intake');
    let c2 = this.getChildMeshEx('iengine', 'oil pan');
    let c3 = this.getChildMeshEx('iengine', 'air filter');
    let c4 = this.getChildMeshEx('iengine', 'exhaust');
    let mat = this.scene.getMaterialByName('transparent');
    [c1, c2, c3, c4].forEach((m) => {
      if (boo) {
        mat = this.scene.getMaterialByName(m.mid);
      }
      m.material = mat;
    }) */
    //'exhaust'
  }
  showIDG(boo = true) {
    let idg = this.getMesh('imodel');
    idg.setEnabled(boo);
  }
  showEngine(boo = true) {
    let engine = this.getMesh('iengine');
    engine.setEnabled(boo);
  }
  aID
  smoke
  pemit
  xstartEngineAnim() {
    let target = { x: 0.07, y: 1.11, z: -0.0968 };
    let distance = 3.1;
    let yaw = -46
    let pitch = 1
    this.moveCameraTo(null, { target, distance, yaw, pitch });
    this.showIDG(false);
    this.showEngine()
    this.scene.animationGroups.forEach((anim) => {
      anim.play(true)
    })
    return;
    /* let c = 0
    let anim = (t) => {
      if (c % 60 === 0) {
        c = 0
        this.debug_ag.forEach((anim) => {
          anim.animatables.forEach((a) => {
            console.log(t, a.masterFrame)
          })
        })
      }
      c++;
      this.aID = requestAnimationFrame(anim);
    }
    requestAnimationFrame(anim); */
    if (!this.pemit) {
      let particleEmitter = BABYLON.MeshBuilder.CreateBox("particleEmitter", { size: 0.05 }, this.scene);
      particleEmitter.position = new BABYLON.Vector3(0.67, 0.97, 0.197);
      particleEmitter.rotation.x = BABYLON.Tools.ToRadians(90);
      particleEmitter.isVisible = false;
      this.pemit = particleEmitter;
    }

    let smoke = BABYLON.ParticleHelper.CreateAsync("smoke", this.scene).then((set) => {
      set.emitter = this.pemit;
      set.start(this.pemit);
      this.smoke = set;
      for (const sys of set.systems) {
        /* sys.emitter.x=0.67
        sys.emitter.y=0.96
        sys.emitter.z=0.197 */
        //sys.emitRate=10; 
        sys.minLifeTime = 1
        sys.maxLifeTime = 3;
        sys.emitRate = 3
        sys.gravity.z = 9;
        sys.blendMode = 4;
        /* sys.direction1 = new BABYLON.Vector3(0, 1, 1);
        sys.direction2 = new BABYLON.Vector3(0, -1, 1);
        sys.gravity = new BABYLON.Vector3(0, 0, 0.5); */
      }

    })

  }
  idgAnimStatus:any=false;
  startEngineAnim(){
    this.idgAnimStatus=true;
    this.profileForAnim(false);
    this.scene.animationGroups.forEach((anim) => {
      anim.play(true)
    })

  }
  stopEngineAnim(){
    this.idgAnimStatus=false;
    this.profileForAnim(true);
    this.scene.stopAllAnimations();
  }
  stopSceneAnim(){
    this.scene.stopAllAnimations();
    this.scene.animationGroups[0].reset()
  }
  profileForAnim(boo){
    
    let p0=this.ctrlServ.getChildMeshEx("imodel","element-generator")
    let p1=this.ctrlServ.getChildMeshEx('imodel','element-cylinder head');
    let p2=this.ctrlServ.getChildMeshEx('imodel','element-engine_block');
    let p3=this.ctrlServ.getChildMeshEx("imodel","element-generator_exterior")
    let p4=this.ctrlServ.getChildMeshEx("imodel","element-oil pan")
    let p5=this.ctrlServ.getChildMeshEx("imodel","element-oil_filter_attach")
    let p6=this.ctrlServ.getChildMeshEx("imodel","element-exhaust manifold")
    let p7=this.ctrlServ.getChildMeshEx("imodel","element-oil_filter")
    //let m1 =this.getChildMeshEx(null,"generator_exterior",p0);
    let m1=this.getChildMeshEx(null,"oilpath_001",p7);
    let m2=this.getChildMeshEx(null,"oilpath_002",p5);
    let m3=this.getChildMeshEx(null,"oil",p4);
    let em2 = this.getChildMeshEx("imodel","element-rocker arm cover");;
    let em3 = this.getChildMeshEx("imodel","element-crank_bearings");
    let em4 = this.getChildMeshEx("imodel","element-crank_bearings_cap");
    let em5 = this.getChildMeshEx("imodel","element-crankcase_vent");
   // let m5 = this.getChildMeshEx(null,"cylinder_sleeves",p2);
    //let m6 = this.getChildMeshEx(null,"engine_block",p2);
    [p1, p2, p3,p4,p5,p6,p7].forEach((m)=>{
      m.isVisible=boo
      m.getChildren().forEach((_m)=>{
      _m.isVisible=boo
      })
     // m.setEnabled(boo);
    });
    [m1,m2,m3,em2,em3,em4,em5].forEach((m)=>{
     // m.setEnabled(true);
     m.isVisible=true;
     m.getChildren().forEach((_m)=>{
      _m.isVisible=true
      })
    })
  }
  xstopEngineAnim() {
    /* this.smoke.dispose();
    this.smoke = null; */
    cancelAnimationFrame(this.aID);
    this.scene.stopAllAnimations();
    this.showEngine(false);
    this.showIDG();
    this.changeCamView('home', false);
  }
  addIDGSmoke(){
    if (!this.pemit) {
      let particleEmitter = BABYLON.MeshBuilder.CreateBox("particleEmitter", { size: 0.05 }, this.scene);
      particleEmitter.position = new BABYLON.Vector3(-0.18, 1.8, -0.41);
      //particleEmitter.rotation.x = BABYLON.Tools.ToRadians(90);
      particleEmitter.isVisible = false;
      this.pemit = particleEmitter;
    }

    let smoke = BABYLON.ParticleHelper.CreateAsync("smoke", this.scene).then((set) => {
      set.emitter = this.pemit;
      set.start(this.pemit);
      this.smoke = set;
      for (const sys of set.systems) {
        /* sys.emitter.x=0.67
        sys.emitter.y=0.96
        sys.emitter.z=0.197 */
        //sys.emitRate=10; 
        sys.minLifeTime = 1
        sys.maxLifeTime = 3;
        sys.emitRate = 3
       // sys.gravity.y = 9;
        //sys.blendMode = 4;
        /* sys.direction1 = new BABYLON.Vector3(0, 1, 1);
        sys.direction2 = new BABYLON.Vector3(0, -1, 1);
        sys.gravity = new BABYLON.Vector3(0, 0, 0.5); */
      }
    })
  }
  removeIDGSmoke(){
    this.smoke.dispose();
    this.smoke = null;
  }
  /**
   * code to fetch shapes and objects def for objects.json 
   *  and components def
   */
  getObjDef() {
    let scope = this;
    var el = scope.datauxview.getElementId('imodel');
    var mesh = scope.dfx.getElementMesh(el);
    var meshes = mesh.getChildren();
    let shapes = [];
    let objects = [];
    let controls = [];
    meshes.forEach((m) => {
      if(m.getClassName()==='TransformNode'){
        return
      }
      let mname = scope.getMeshName(m.name);
      let obj = {}
      obj["dfx-" + mname] = { "model": mname, "material": "custom-included", "size": 1 }
      shapes.push(obj);
      let prop = { "type": "static", "parent": "", "name": mname, "model": "dfx-" + mname, "place": { "pos": { "x": 0, "y": 0, "z": 0 }, "rot": { "x": 0, "y": 0, "z": 0 } } }
      objects.push(prop)
      let cobj=this.getChildControlsDef(m,mname)
      shapes=shapes.concat(cobj.shapes)
      objects=objects.concat(cobj.objects)
      let o = {
        "name": mname, "id": mname, "children": cobj.controls, "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false
      }
      controls.push(o)
    })
    return { shapes, objects, controls }
  }
  getObjDefJSON() {
    let def = this.getObjDef();
    console.log("------- SHAPES -------");
    console.log(JSON.stringify(def.shapes))
    console.log("------- OBJECTS -------");
    console.log(JSON.stringify(def.objects));
    console.log("------- CONTROLS -------");
    console.log(JSON.stringify(def.controls));
  }
  getChildControlsDef(mesh,mn=null) {
    let scope = this;
    var meshes = mesh.getChildren();
    let shapes = [];
    let objects = [];
    let controls = [];
    if(mn){
      let o = {
        "name": mn, "id": mn, "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false
      }
      controls.push(o)
    }
    meshes.forEach((m) => {
      if(m.getClassName()==='TransformNode'){
        return
      }
      let mname = scope.getMeshName(m.name);
      let obj = {}
      obj["dfx-" + mname] = { "model": mname, "material": "custom-included", "size": 1 }
      shapes.push(obj);
      let prop = { "type": "static", "parent": "", "name": mname, "model": "dfx-" + mname, "place": { "pos": { "x": 0, "y": 0, "z": 0 }, "rot": { "x": 0, "y": 0, "z": 0 } } }
      objects.push(prop)
      let o = {
        "name": mname, "id": mname, "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false
      }
      controls.push(o)
    })
    return { shapes, objects, controls }
  }

  quizPanelClose() {
    this.showQuizCloseBtn = !true;
    this.broadcastInfo({ src: 'main', event: 'changeview', data: "network", key: '' });
  }

  resetShipCompCtls() {
    for (let m in this.shipCompsCntls) {
      let catg = this.shipCompsCntls[m];
      catg.forEach((c) => {
        c.focus = false;
        c.opacity = 'solid';
        c.selected = true;
        c.visible = true;
      })
    }
  }

  objDrillDownDataPath: any = [];
  onLocCtl(event, key) {
    let info;
    let objData = this.shipCompsCntls[event.key];
    let IndexData = objData.findIndex(data => data.id == event.id);
    if (IndexData != -1) {
      info = this.shipCompsCntls[event.key][IndexData]
      this.shipCompsCntls[event.key] = info['children']
      this.generateParentId(info['children'], event.id);
      this.objDrillDownDataPath[event.id] = objData;
    }
    this.resetShipCompCtls();
    this.bckupShip_comp_ctl_list = JSON.stringify(this.shipCompsCntls)
  }

  generateParentId(children, parentId) {
    children.forEach(element => {
      element['parentId'] = parentId;
    });
  }

  closeBack(comp, key) {
    if (this.objDrillDownDataPath[comp.parentId] != undefined) {
      this.shipCompsCntls[key] = this.objDrillDownDataPath[comp.parentId];
      this.resetShipCompCtls();
      this.broadcastInfo({ src: 'starterapp', event: 'drill-down', data: this.shipCompsCntls, key: "" });
    }
  }
  excludeRHIBLighting(mesh) {
    let lights = this.scene.lights;
    lights.forEach((light) => {
      //light.excludedMeshes.push(mesh);
      this.applyExlude(light, mesh);
    })
  }
  applyExlude(light, mesh) {
    light.excludedMeshes.push(mesh);
    mesh.getChildMeshes().forEach((m) => {
      light.excludedMeshes.push(m);
    }
    );
  }
  backMechanical(){
    this.appCourseAnimation = false;
    this.broadcastInfo({ src: 'starterapp', event: 'mechanical', data: true });
  }
  getOilFlowElements(){
    let m = this.getMesh('imodel');
    m.getChildMeshes().forEach((mesh)=>{
      if(mesh.isEnabled()){
         if( mesh.material&&mesh.material.name){
             if(mesh.material.name.includes('oil_ramp')){
               mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.UVKind,true)
                this.oilanim_objs.push(mesh);
             }
         }
      }
  })
  }
  initAnimateOilFlow(){
    let engine=this.scene.getEngine();
    this.getOilFlowElements();
    this.scene.registerBeforeRender(() => {
      if(this.engineAnimationMode){
        this.oilanim_objs.forEach((m)=>{
          let uvs = m.getVerticesData(BABYLON.VertexBuffer.UVKind);
          uvs = Array.from(uvs); //converstion of float32array to array in order to pop and unshift
          for (var i = 0; i < uvs.length; i+=2) {
              uvs[i]+=engine.getDeltaTime()/1000
          }
          m.updateVerticesData(BABYLON.VertexBuffer.UVKind, uvs);
        })
          
      }
    });
  
  }
}
